<template>
    <div>
        <div class="col-lg-12" style="padding-top: 20px; padding-bottom: 20px">
            <div class="row">
                <modal :show.sync="modals.viewquotation" class="modal-eprf" centered>
                    <b-card class="card text-center"
                        style="text-align: center; background-color: white; box-shadow: none;" border-variant="primary"
                        header="QUOTATION REQUEST" header-bg-variant="primary" header-text-variant="white">
                        <template #header>
                            <div class="row">
                                <div class="col-lg text-left">
                                    <h4 class="mb-0">QUOTATION REQUEST - {{ referenceno }}</h4>
                                </div>
                                <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                                    <base-button class="btn-icon btn-cancel btn-round btn-sm">
                                        <i style="
                    transform: translate(-50%, -50%);
                    color: white;
                    font-weight: 900;
                    font-size: 12px;
                  " class="tim-icons icon-simple-remove" @click="modals.viewquotation = false"></i>
                                    </base-button>
                                </div>
                            </div>
                        </template>
                        <div class="col-lg-12">
                            <div class="modal-body-scrollable" style="max-height: 70vh; overflow-y: auto;">
                                <div style="padding: 5px 20px 0px 20px;">
                                    <div class="row">
                                        <div class="col-6">
                                            <p
                                                style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                Reference No.
                                            </p>
                                            <p
                                                style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                                                {{
                                                    referenceno }}
                                            </p>
                                        </div>

                                        <div class="col-6">
                                            <p
                                                style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                Service Location
                                            </p>
                                            <p
                                                style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                                                {{
                                                    servicelocation }}
                                            </p>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="row">
                                        <div class="col-6">
                                            <p
                                                style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                PIC Name
                                            </p>
                                            <p
                                                style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                                                {{
                                                    picname
                                                }}
                                            </p>
                                        </div>

                                        <div class="col-6">
                                            <p
                                                style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                PIC Phone No.
                                            </p>
                                            <p
                                                style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                                                {{
                                                    picphoneno }}
                                            </p>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="row">
                                        <div class="col-12">
                                            <p
                                                style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                Customer Remarks
                                            </p>
                                            <p
                                                style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                                                {{
                                                    customerremark }}
                                            </p>

                                        </div>
                                    </div>
                                    <br />
                                    <div v-if="(positionid == 4 && pagestatus == 100) || (positionid != 4 && pagestatus == 100) || (positionid == 4 && pagestatus == 2)"
                                        class="row">
                                        <div class="col-9">
                                            <div>
                                                <p
                                                    style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                    Subject Line
                                                </p>
                                                <p
                                                    style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                                                    {{
                                                        subjectline }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-3 text-right" style="margin-top: 2%; ">
                                            <base-button type="primary" v-on:click="createQuo()">
                                                <i style="color: white; font-size: 18px; font-weight: 900"
                                                    class="tim-icons icon-cloud-download-93"></i>&nbsp;
                                                Print</base-button>
                                        </div>
                                    </div><br />
                                    <el-table :data="allorderitems" :header-cell-style="{
                                        background: '#358DCC',
                                        border: 'transparent',
                                        'font-size': '14px',
                                        'font-weight': '400',
                                        color: '#FFFFFF',
                                    }" :row-style="tableRowClassName">
                                        <el-table-column label="No." width="100" align="center">
                                            <template slot="header" slot-scope="scope">
                                                <div><span>{{ scope.column.label }}</span></div>
                                            </template>
                                            <div slot-scope="scope">
                                                <p style="font-size: 14px; color: #707070">
                                                    {{ scope.row.indexing }}
                                                </p>
                                            </div>
                                        </el-table-column>
                                        <el-table-column label="Product" :min-width="150" prop="filename"
                                            align="center">
                                            <template slot="header" slot-scope="scope">
                                                <div><span>{{ scope.column.label }}</span>
                                                </div>
                                            </template>
                                            <div slot-scope="scope" align="left">
                                                <p v-if="scope.row.indexing < allorderitems.length"
                                                    style="font-size: 14px; color: #707070">
                                                    {{ scope.row.waste_type.name }}
                                                    <br />
                                                    Remark: {{ scope.row.remark }}
                                                </p>
                                                <p v-else-if="scope.row.waste_type.name == 'GRAND TOTAL'"
                                                    style="font-size: 14px; color: #000; font-weight: bold">
                                                    {{ scope.row.waste_type.name }}
                                                </p>
                                                <p v-else style="font-size: 14px; color: #707070;">
                                                    {{ scope.row.waste_type.name }}
                                                </p>
                                            </div>
                                        </el-table-column>
                                        <el-table-column label="Qty (kg)" :min-width="50" prop="filename"
                                            align="center">
                                            <template slot="header" slot-scope="scope">
                                                <div><span>{{ scope.column.label }}</span>
                                                </div>
                                            </template>
                                            <div slot-scope="scope" align="center">
                                                <p style="font-size: 14px; color: #707070">
                                                    {{ scope.row.quantity }}
                                                </p>
                                            </div>
                                        </el-table-column>
                                        <el-table-column label="Rate (RM/Kg)" :min-width="100" align="center">
                                            <div v-if="positionid == 4" slot-scope="scope">
                                                <p style="font-size: 14px; color: #707070; margin-right: 16%;">
                                                    {{ scope.row.rate }}
                                                </p>
                                            </div>
                                            <div v-else-if="positionid != 4" slot-scope="scope">
                                                <input
                                                    v-if="scope.row.waste_type.name != 'GRAND TOTAL' && scope.row.waste_type.name != 'Transportation rate'"
                                                    type="number" min="0" step=".01"
                                                    style="color: #707070; text-align: right;"
                                                    :class="{ 'custom-input': true }" v-model="scope.row.rate"
                                                    @input="rateChange(scope.$index)" />
                                            </div>
                                        </el-table-column>
                                        <el-table-column label="Price (RM)" :min-width="100" align="center">
                                            <div v-if="scope.row.waste_type.name != 'Transportation rate' && scope.row.waste_type.name != 'GRAND TOTAL'"
                                                slot-scope="scope">
                                                <p
                                                    style="text-align: right; font-size: 14px; color: #707070; margin-right: 16%;">
                                                    {{ scope.row.amount }}
                                                </p>
                                            </div>
                                            <div v-else-if="scope.row.waste_type.name == 'Transportation rate'">
                                                <p v-if="positionid == 4"
                                                    style="text-align: right; font-size: 14px; color: #707070; margin-right: 16%;">
                                                    {{ transportrate }}
                                                </p>
                                                <p v-if="positionid != 4 && pagestatus == 100"
                                                    style=" font-size: 14px; color: #707070; text-align: right; margin-right: 16%;">
                                                    {{ transportrate }}
                                                </p>
                                                <input v-else-if="positionid != 4 && pagestatus != 100"
                                                    slot-scope="scope" type="number" min="0" step=".01"
                                                    style="color: #707070; text-align: right;"
                                                    :class="{ 'custom-input': true }"
                                                    @input="transportrate = transportrate === '' || transportrate < 0 ? 0 : transportrate"
                                                    v-model="transportrate" />
                                            </div>
                                            <div v-else-if="scope.row.waste_type.name == 'GRAND TOTAL'"
                                                slot-scope="scope">
                                                <p v-if="positionid != 4"
                                                    style="text-align: right; margin-right: 16%; font-size: 14px; color: #707070">
                                                    {{ totalamount.toLocaleString() }}
                                                </p>
                                                <p v-else-if="positionid == 4"
                                                    style="text-align: right; margin-right: 16%; font-size: 14px; color: #707070">
                                                    {{ scope.row.amount }}
                                                </p>
                                            </div>
                                        </el-table-column>
                                    </el-table>
                                    <!--only dekat pic boleh isi-->
                                    <br />
                                    <div v-if="positionid != 4">
                                        <p
                                            style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                            Subject Line <span style="color: #EC1B23">*</span>
                                        </p>
                                        <input type="text" v-model="subjectline" :class="{ 'custom-input': true }" />
                                        <br /><br />
                                    </div>

                                    <div v-if="positionid != 4">
                                        <p
                                            style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                            Delivery Term <span style="color: #EC1B23">*</span>
                                        </p>

                                        <div class="row">
                                            <div class="col-lg-3">
                                                <input type="number" min='0' v-model="deliveryterm"
                                                    :class="{ 'custom-input': true }" />
                                            </div>
                                            <div class="col-lg-3 text-left" style="padding-bottom: 5px">
                                                <el-select class="select-info tab select-width" placeholder="Select"
                                                    v-model="selects.day" style="border-bottom: 1px solid lightgray">
                                                    <el-option v-for="option in selects.days" class="select-info"
                                                        :value="option.value" :label="option.label"
                                                        :key="option.value"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <br />
                                    </div>

                                    <!-- <br /> -->

                                    <div v-if="positionid != 4">
                                        <p
                                            style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                            Payment Term <span style="color: #EC1B23">*</span>
                                        </p>

                                        <div class="row">
                                            <div class="col-lg-3">
                                                <input type="number" min='0' v-model="paymentterm"
                                                    :class="{ 'custom-input': true }" />
                                            </div>
                                            <div class="col-lg-3 text-left">
                                                <p style="color: #707070; font-size: 14px;">Days</p>
                                            </div>
                                        </div>

                                        <br />
                                    </div>

                                    <!-- <br /> -->

                                    <div v-if="positionid != 4">
                                        <p
                                            style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                            Validity <span style="color: #EC1B23">*</span>
                                        </p>
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <input type="number" min='0' v-model="validity"
                                                    :class="{ 'custom-input': true }" />
                                            </div>
                                            <div class="col-lg-3 text-left">
                                                <p style="color: #707070; font-size: 14px;">Days</p>
                                            </div>
                                        </div>
                                        <br />
                                    </div>

                                    <div class="row">
                                        <div class="col-4">

                                            <div
                                                v-if="(positionid == 4 && pagestatus == 100) || (positionid != 4 && pagestatus == 100) || (positionid == 4 && pagestatus == 2)">
                                                <p
                                                    style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                    Delivery Term
                                                </p>
                                                <p
                                                    style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                                                    {{
                                                        deliveryterm }} {{
                                                        deliverytermunit }}
                                                </p>
                                                <br />
                                            </div>
                                        </div>
                                        <div class="col-4">
                                            <div
                                                v-if="(positionid == 4 && pagestatus == 100) || (positionid != 4 && pagestatus == 100) || (positionid == 4 && pagestatus == 2)">
                                                <p
                                                    style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                    Payment Term
                                                </p>
                                                <p
                                                    style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                                                    {{
                                                        paymentterm }} <span
                                                        style="color: #707070; font-size: 14px;">Days</span>
                                                </p>
                                                <br />
                                            </div>
                                        </div>
                                        <div class="col-4">
                                            <div
                                                v-if="(positionid == 4 && pagestatus == 100) || (positionid != 4 && pagestatus == 100) || (positionid == 4 && pagestatus == 2)">
                                                <p
                                                    style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                    Validity
                                                </p>
                                                <p
                                                    style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                                                    {{
                                                        validity }} <span
                                                        style="color: #707070; font-size: 14px;">Days</span>
                                                </p>
                                                <br />
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        v-if="(positionid == 4 && pagestatus == 100) || (positionid != 4 && pagestatus == 100) || (positionid == 4 && pagestatus == 2)">
                                        <p
                                            style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                            Remarks
                                        </p>
                                        <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">{{
                                            remarks }}
                                        </p>
                                        <br />
                                    </div>

                                    <div v-else-if="positionid != 4">
                                        <p
                                            style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                            Remarks
                                        </p>
                                        <input type="text" v-model="remarks" :class="{ 'custom-input': true }" />

                                        <br /><br />
                                    </div>

                                    <p v-if="currentstatus > 3"
                                        style="color: #707070; font-size: 15px; font-weight: bold; text-align: left; margin-bottom: -10px;">
                                        Quotation Supporting Document
                                    </p>

                                    <div v-if="currentstatus > 3" class="col-lg-12">
                                        <div v-if="allquotationdocs.length === 0">
                                            <p
                                                style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                No
                                                file
                                                uploaded.
                                            </p>
                                        </div>
                                        <div v-for="(item, index) in allquotationdocs" :key="index">
                                            <div class="row">
                                                <div class="col-lg-1 text-center">
                                                    <p style="color: #A5A5A5; font-size: 14px;">{{ index + 1 }}.</p>
                                                </div>
                                                <div class="col-lg-10 text-left">
                                                    <p style="color: #A5A5A5; font-size: 14px;">{{ item.filename }}</p>
                                                </div>
                                                <div class="col-lg-1 text-center">
                                                    <a :href="item.fileurl" :download="item.filename">
                                                        <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br />

                                </div>
                            </div>
                            <!--management only-->
                            <div
                                v-if="(positionid == 4 && pagestatus != 100) || (positionid != 4 && pagestatus != 100)">
                                <div v-if="positionid == 4" class="col-lg-12 text-right">
                                    <base-button @click="modals.disputereason = true" type="cancel"
                                        style="margin-right: 8px;">Dispute</base-button>
                                    <base-button @click="acceptQuotation" type="primary">Accept</base-button>
                                </div>
                                <!-- ni kena status 4 -->
                                <div v-else-if="positionid != 4 && pagestatus == 4" class="col-lg-12 text-right">
                                    <base-button @click="picUpdateQuotation" :disabled="piccanapprove"
                                        type="primary">Update</base-button>
                                </div>
                                <!--pic, main-->
                                <div v-else-if="positionid != 4" class="col-lg-12 text-right">
                                    <base-button @click="modals.picdisputereason = true" type="cancel"
                                        style="margin-right: 8px;">Dispute</base-button>
                                    <base-button @click="acceptQuote" :disabled="piccanapprove"
                                        type="primary">Accept</base-button>
                                </div>

                            </div>
                        </div>
                    </b-card>
                </modal>

                <modal :show.sync="modals.viewupdatequotation" class="modal-eprf" centered>
                    <b-card class="card text-center"
                        style="text-align: center; background-color: white; box-shadow: none;" border-variant="primary"
                        header="UPDATE QUOTATION REQUEST" header-bg-variant="primary" header-text-variant="white">
                        <template #header>
                            <div class="row">
                                <div class="col-lg text-left">
                                    <h4 class="mb-0">UPDATE QUOTATION REQUEST - {{ referenceno }}</h4>
                                </div>
                                <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                                    <base-button class="btn-icon btn-cancel btn-round btn-sm">
                                        <i style="
                    transform: translate(-50%, -50%);
                    color: white;
                    font-weight: 900;
                    font-size: 12px;
                  " class="tim-icons icon-simple-remove" @click="modals.viewupdatequotation = false"></i>
                                    </base-button>
                                </div>
                            </div>
                        </template>
                        <div class="col-lg-12">
                            <div class="modal-body-scrollable" style="max-height: 70vh; overflow-y: auto;">
                                <div style="padding: 5px 20px 0px 20px;">
                                    <div class="row">
                                        <div class="col-6">
                                            <p
                                                style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                Reference No.
                                            </p>
                                            <p
                                                style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                                                {{
                                                    referenceno }}
                                            </p>
                                        </div>

                                        <div class="col-6">
                                            <p
                                                style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                Service Location
                                            </p>
                                            <p
                                                style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                                                {{
                                                    servicelocation }}
                                            </p>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="row">
                                        <div class="col-6">
                                            <p
                                                style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                PIC Name
                                            </p>
                                            <p
                                                style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                                                {{
                                                    picname
                                                }}
                                            </p>
                                        </div>

                                        <div class="col-6">
                                            <p
                                                style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                PIC Phone No.
                                            </p>
                                            <p
                                                style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                                                {{
                                                    picphoneno }}
                                            </p>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="row">
                                        <div class="col-12">
                                            <p
                                                style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                Customer Remarks
                                            </p>
                                            <p
                                                style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                                                {{
                                                    customerremark }}
                                            </p>

                                        </div>
                                    </div>
                                    <br />
                                    <div class="row">
                                        <div class="col-12">
                                            <p
                                                style="color: #707070; opacity: 0.7;  text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                Quotation Disputed Reason <span>
                                                    <i @click="modals.viewlog = true" style="margin-top: -5px;"
                                                        class="tim-icons icon-chat-33 download-icon"></i>
                                                </span>
                                            </p>
                                            <p
                                                style="color: #5A5A5A;  opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px;">
                                                {{
                                                    quotationdisputedreason
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                    <br />
                                    <div v-if="(positionid == 4 && pagestatus == 100) || (positionid != 4 && pagestatus == 100) || (positionid == 4 && pagestatus == 2)"
                                        class="row">
                                        <div class="col-9">
                                            <div>
                                                <p
                                                    style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                    Subject Line
                                                </p>
                                                <p
                                                    style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                                                    {{
                                                        subjectline }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-3 text-right" style="margin-top: 2%; ">
                                            <base-button type="primary" v-on:click="createQuo()">
                                                <i style="color: white; font-size: 18px; font-weight: 900"
                                                    class="tim-icons icon-cloud-download-93"></i>&nbsp;
                                                Print</base-button>
                                        </div>
                                    </div><br />
                                    <el-table :data="allorderitems" :header-cell-style="{
                                        background: '#358DCC',
                                        border: 'transparent',
                                        'font-size': '14px',
                                        'font-weight': '400',
                                        color: '#FFFFFF',
                                    }" :row-style="tableRowClassName">
                                        <el-table-column label="No." width="100" align="center">
                                            <template slot="header" slot-scope="scope">
                                                <div><span>{{ scope.column.label }}</span></div>
                                            </template>
                                            <div slot-scope="scope">
                                                <p style="font-size: 14px; color: #707070">
                                                    {{ scope.row.indexing }}
                                                </p>
                                            </div>
                                        </el-table-column>
                                        <el-table-column label="Product" :min-width="150" prop="filename"
                                            align="center">
                                            <template slot="header" slot-scope="scope">
                                                <div><span>{{ scope.column.label }}</span>
                                                </div>
                                            </template>
                                            <div slot-scope="scope" align="left">
                                                <p v-if="scope.row.indexing < allorderitems.length"
                                                    style="font-size: 14px; color: #707070">
                                                    {{ scope.row.waste_type.name }}
                                                    <br />
                                                    Remark: {{ scope.row.remark }}
                                                </p>
                                                <p v-else-if="scope.row.waste_type.name == 'GRAND TOTAL'"
                                                    style="font-size: 14px; color: #000; font-weight: bold">
                                                    {{ scope.row.waste_type.name }}
                                                </p>
                                                <p v-else style="font-size: 14px; color: #707070;">
                                                    {{ scope.row.waste_type.name }}
                                                </p>
                                            </div>
                                        </el-table-column>
                                        <el-table-column label="Qty (kg)" :min-width="50" prop="filename"
                                            align="center">
                                            <template slot="header" slot-scope="scope">
                                                <div><span>{{ scope.column.label }}</span>
                                                </div>
                                            </template>
                                            <div slot-scope="scope" align="center">
                                                <p style="font-size: 14px; color: #707070">
                                                    {{ scope.row.quantity }}
                                                </p>
                                            </div>
                                        </el-table-column>
                                        <el-table-column label="Rate (RM/Kg)" :min-width="100" align="center">
                                            <div v-if="positionid == 4" slot-scope="scope">
                                                <p style="font-size: 14px; color: #707070; margin-right: 16%;">
                                                    {{ scope.row.rate }}
                                                </p>
                                            </div>
                                            <div v-else-if="positionid != 4" slot-scope="scope">
                                                <input
                                                    v-if="scope.row.waste_type.name != 'GRAND TOTAL' && scope.row.waste_type.name != 'Transportation rate'"
                                                    type="number" min="0" step=".01"
                                                    style="color: #707070; text-align: right;"
                                                    :class="{ 'custom-input': true }" v-model="scope.row.rate"
                                                    @input="rateChange(scope.$index)" />
                                            </div>
                                        </el-table-column>
                                        <el-table-column label="Price (RM)" :min-width="100" align="center">
                                            <div v-if="scope.row.waste_type.name != 'Transportation rate' && scope.row.waste_type.name != 'GRAND TOTAL'"
                                                slot-scope="scope">
                                                <p
                                                    style="text-align: right; font-size: 14px; color: #707070; margin-right: 16%;">
                                                    {{ scope.row.amount }}
                                                </p>
                                            </div>
                                            <div v-else-if="scope.row.waste_type.name == 'Transportation rate'">
                                                <p v-if="positionid == 4"
                                                    style="text-align: right; font-size: 14px; color: #707070; margin-right: 16%;">
                                                    {{ transportrate }}
                                                </p>
                                                <p v-if="positionid != 4 && pagestatus == 100"
                                                    style=" font-size: 14px; color: #707070; text-align: right; margin-right: 16%;">
                                                    {{ transportrate }}
                                                </p>
                                                <input v-else-if="positionid != 4 && pagestatus != 100"
                                                    slot-scope="scope" type="number" min="0" step=".01"
                                                    style="color: #707070; text-align: right;"
                                                    :class="{ 'custom-input': true }"
                                                    @input="transportrate = transportrate === '' || transportrate < 0 ? 0 : transportrate"
                                                    v-model="transportrate" />
                                            </div>
                                            <div v-else-if="scope.row.waste_type.name == 'GRAND TOTAL'"
                                                slot-scope="scope">
                                                <p v-if="positionid != 4 && pagestatus == 4"
                                                    style="text-align: right; margin-right: 16%; font-size: 14px; color: #707070">
                                                    <!-- {{ scope.row.amount }} -->
                                                    {{ totalamount.toLocaleString() }}
                                                </p>
                                                <p v-else-if="positionid != 4"
                                                    style="text-align: right; margin-right: 16%; font-size: 14px; color: #707070">
                                                    {{ totalamount.toLocaleString() }}
                                                </p>
                                                <p v-else-if="positionid == 4"
                                                    style="text-align: right; margin-right: 16%; font-size: 14px; color: #707070">
                                                    {{ scope.row.amount }}
                                                </p>
                                            </div>
                                        </el-table-column>
                                    </el-table>
                                    <!--only dekat pic boleh isi-->
                                    <br />
                                    <div v-if="positionid != 4">
                                        <p
                                            style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                            Subject Line <span style="color: #EC1B23">*</span>
                                        </p>
                                        <input type="text" v-model="subjectline" :class="{ 'custom-input': true }" />
                                        <br /><br />
                                    </div>

                                    <div v-if="positionid != 4">
                                        <p
                                            style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                            Delivery Term <span style="color: #EC1B23">*</span>
                                        </p>

                                        <div class="row">
                                            <div class="col-lg-3">
                                                <input type="number" min='0' v-model="deliveryterm"
                                                    :class="{ 'custom-input': true }" />
                                            </div>
                                            <div class="col-lg-3 text-left" style="padding-bottom: 5px">
                                                <el-select class="select-info tab select-width" placeholder="Select"
                                                    v-model="selects.day" style="border-bottom: 1px solid lightgray">
                                                    <el-option v-for="option in selects.days" class="select-info"
                                                        :value="option.value" :label="option.label"
                                                        :key="option.value"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                        <br />
                                    </div>

                                    <!-- <br /> -->

                                    <div v-if="positionid != 4">
                                        <p
                                            style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                            Payment Term <span style="color: #EC1B23">*</span>
                                        </p>

                                        <div class="row">
                                            <div class="col-lg-3">
                                                <input type="number" min='0' v-model="paymentterm"
                                                    :class="{ 'custom-input': true }" />
                                            </div>
                                            <div class="col-lg-3 text-left">
                                                <p style="color: #707070; font-size: 14px;">Days</p>
                                            </div>
                                        </div>

                                        <br />
                                    </div>

                                    <!-- <br /> -->

                                    <div v-if="positionid != 4">
                                        <p
                                            style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                            Validity <span style="color: #EC1B23">*</span>
                                        </p>
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <input type="number" min='0' v-model="validity"
                                                    :class="{ 'custom-input': true }" />
                                            </div>
                                            <div class="col-lg-3 text-left">
                                                <p style="color: #707070; font-size: 14px;">Days</p>
                                            </div>
                                        </div>
                                        <br />
                                    </div>

                                    <div class="row">
                                        <div class="col-4">

                                            <div
                                                v-if="(positionid == 4 && pagestatus == 100) || (positionid != 4 && pagestatus == 100) || (positionid == 4 && pagestatus == 2)">
                                                <p
                                                    style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                    Delivery Term
                                                </p>
                                                <p
                                                    style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                                                    {{
                                                        deliveryterm }} {{
                                                        deliverytermunit }}
                                                </p>
                                                <br />
                                            </div>
                                        </div>
                                        <div class="col-4">
                                            <div
                                                v-if="(positionid == 4 && pagestatus == 100) || (positionid != 4 && pagestatus == 100) || (positionid == 4 && pagestatus == 2)">
                                                <p
                                                    style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                    Payment Term
                                                </p>
                                                <p
                                                    style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                                                    {{
                                                        paymentterm }} <span
                                                        style="color: #707070; font-size: 14px;">Days</span>
                                                </p>
                                                <br />
                                            </div>
                                        </div>
                                        <div class="col-4">
                                            <div
                                                v-if="(positionid == 4 && pagestatus == 100) || (positionid != 4 && pagestatus == 100) || (positionid == 4 && pagestatus == 2)">
                                                <p
                                                    style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                    Validity
                                                </p>
                                                <p
                                                    style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                                                    {{
                                                        validity }} <span
                                                        style="color: #707070; font-size: 14px;">Days</span>
                                                </p>
                                                <br />
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        v-if="(positionid == 4 && pagestatus == 100) || (positionid != 4 && pagestatus == 100) || (positionid == 4 && pagestatus == 2)">
                                        <p
                                            style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                            Remarks
                                        </p>
                                        <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">{{
                                            remarks }}
                                        </p>
                                        <br />
                                    </div>

                                    <div v-else-if="positionid != 4">
                                        <p
                                            style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                            Remarks
                                        </p>
                                        <input type="text" v-model="remarks" :class="{ 'custom-input': true }" />

                                        <br /><br />
                                    </div>

                                    <p v-if="currentstatus > 3"
                                        style="color: #707070; font-size: 15px; font-weight: bold; text-align: left; margin-bottom: -10px;">
                                        Quotation Supporting Document
                                    </p>

                                    <div v-if="currentstatus > 3" class="col-lg-12">
                                        <div v-if="allquotationdocs.length === 0">
                                            <p
                                                style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                No
                                                file
                                                uploaded.
                                            </p>
                                        </div>
                                        <div v-for="(item, index) in allquotationdocs" :key="index">
                                            <div class="row">
                                                <div class="col-lg-1 text-center">
                                                    <p style="color: #A5A5A5; font-size: 14px;">{{ index + 1 }}.</p>
                                                </div>
                                                <div class="col-lg-10 text-left">
                                                    <p style="color: #A5A5A5; font-size: 14px;">{{ item.filename }}</p>
                                                </div>
                                                <div class="col-lg-1 text-center">
                                                    <a :href="item.fileurl" :download="item.filename">
                                                        <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br />

                                </div>
                            </div>
                            <!--management only-->
                            <div
                                v-if="(positionid == 4 && pagestatus != 100) || (positionid != 4 && pagestatus != 100)">
                                <div v-if="positionid == 4" class="col-lg-12 text-right">
                                    <base-button @click="modals.disputereason = true" type="cancel"
                                        style="margin-right: 8px;">Dispute</base-button>
                                    <base-button @click="acceptQuotation" type="primary">Accept</base-button>
                                </div>
                                <!-- ni kena status 4 -->
                                <div v-else-if="positionid != 4 && pagestatus == 4" class="col-lg-12 text-right">
                                    <base-button @click="picUpdateQuotation" :disabled="piccanapprove"
                                        type="primary">Update</base-button>
                                </div>
                                <!--pic, main-->
                                <div v-else-if="positionid != 4" class="col-lg-12 text-right">
                                    <base-button @click="modals.picdisputereason = true" type="cancel"
                                        style="margin-right: 8px;">Dispute</base-button>
                                    <base-button @click="acceptQuote" :disabled="piccanapprove"
                                        type="primary">Accept</base-button>
                                </div>

                            </div>
                        </div>
                    </b-card>
                </modal>

                <modal :show.sync="modals.viewdeliveryorder" class="modal-eprf" centered>
                    <b-card class="card text-center" style="background-color: white; box-shadow: none"
                        border-variant="primary" header="ORDER DETAILS - " header-bg-variant="primary"
                        header-text-variant="white">
                        <template #header>
                            <div class="row">
                                <div class="col-lg text-left">
                                    <h4 class="mb-0">DELIVERY ORDER - {{ referenceno }}</h4>
                                </div>
                                <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                                    <base-button class="btn-icon btn-cancel btn-round btn-sm">
                                        <i style="
                    transform: translate(-50%, -50%);
                    color: white;
                    font-weight: 900;
                    font-size: 12px;
                  " class="tim-icons icon-simple-remove" @click="modals.viewdeliveryorder = false"></i>
                                    </base-button>
                                </div>
                            </div>
                        </template>

                        <div class="col-lg-12">
                            <div class="modal-body-scrollable" style="max-height: 70vh; overflow-y: auto;">
                                <div style="padding: 5px 20px 0px 20px;">
                                    <div class="row">
                                        <div class="col-6">
                                            <p
                                                style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                Reference No.
                                            </p>
                                            <p
                                                style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                                                {{
                                                    referenceno }}
                                            </p>
                                        </div>

                                        <div class="col-6">
                                            <p
                                                style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                Service Location
                                            </p>
                                            <p
                                                style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                                                {{
                                                    servicelocation }}
                                            </p>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="row">
                                        <div class="col-6">
                                            <p
                                                style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                PIC Name
                                            </p>
                                            <p
                                                style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                                                {{
                                                    picname
                                                }}
                                            </p>
                                        </div>

                                        <div class="col-6">
                                            <p
                                                style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                PIC Phone No.
                                            </p>
                                            <p
                                                style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                                                {{
                                                    picphoneno }}
                                            </p>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="row">
                                        <div class="col-12">
                                            <p
                                                style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                Customer Remarks
                                            </p>
                                            <p
                                                style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                                                {{
                                                    customerremark }}
                                            </p>

                                        </div>
                                    </div>
                                    <br />
                                    <div v-if="(positionid != 4 && pagestatus == 9) || (positionid == 4 && pagestatus == 100) || (positionid != 4 && pagestatus == 100) || (positionid == 4 && pagestatus == 2)"
                                        class="row">
                                        <div class="col-9">
                                            <div>
                                                <p
                                                    style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                    Subject Line
                                                </p>
                                                <p
                                                    style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                                                    {{
                                                        subjectline }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-3 text-right" style="margin-top: 2%; ">
                                            <base-button type="primary" v-on:click="createDO()">
                                                <i style="color: white; font-size: 18px; font-weight: 900"
                                                    class="tim-icons icon-cloud-download-93"></i>&nbsp;
                                                Print</base-button>
                                        </div>
                                    </div><br />
                                    <el-table :data="allorderitems" :header-cell-style="{
                                        background: '#358DCC',
                                        border: 'transparent',
                                        'font-size': '14px',
                                        'font-weight': '400',
                                        color: '#FFFFFF',
                                    }" :row-style="tableRowClassName">
                                        <el-table-column label="No." width="100" align="center">
                                            <template slot="header" slot-scope="scope">
                                                <div><span>{{ scope.column.label }}</span></div>
                                            </template>
                                            <div slot-scope="scope">
                                                <p style="font-size: 14px; color: #707070">
                                                    {{ scope.row.indexing }}
                                                </p>
                                            </div>
                                        </el-table-column>
                                        <el-table-column label="Product" :min-width="150" prop="filename"
                                            align="center">
                                            <template slot="header" slot-scope="scope">
                                                <div><span>{{ scope.column.label }}</span>
                                                </div>
                                            </template>
                                            <div slot-scope="scope" align="left">
                                                <p v-if="scope.row.indexing < allorderitems.length"
                                                    style="font-size: 14px; color: #707070">
                                                    {{ scope.row.waste_type.name }}
                                                    <br />
                                                    Remark: {{ scope.row.remark }}
                                                </p>
                                                <p v-else-if="scope.row.waste_type.name == 'GRAND TOTAL'"
                                                    style="font-size: 14px; color: #000; font-weight: bold">
                                                    {{ scope.row.waste_type.name }}
                                                </p>
                                                <p v-else style="font-size: 14px; color: #707070;">
                                                    {{ scope.row.waste_type.name }}
                                                </p>
                                            </div>
                                        </el-table-column>
                                        <el-table-column label="Qty (kg)" :min-width="50" prop="filename"
                                            align="center">
                                            <template slot="header" slot-scope="scope">
                                                <div><span>{{ scope.column.label }}</span>
                                                </div>
                                            </template>
                                            <div slot-scope="scope" align="center">
                                                <p style="font-size: 14px; color: #707070">
                                                    {{ scope.row.quantity }}
                                                </p>
                                            </div>
                                        </el-table-column>
                                        <el-table-column label="Rate (RM/Kg)" :min-width="100" align="center">
                                            <div v-if="positionid == 4 || (positionid != 4 && currentstatus == 100) || (positionid != 4 && currentstatus == 9)"
                                                slot-scope="scope">
                                                <p style="font-size: 14px; color: #707070; margin-right: 16%;">
                                                    {{ scope.row.rate }}
                                                </p>
                                            </div>
                                            <div v-else-if="positionid != 4" slot-scope="scope">
                                                <input
                                                    v-if="scope.row.waste_type.name != 'GRAND TOTAL' && scope.row.waste_type.name != 'Transportation rate'"
                                                    type="number" min="0" step=".01"
                                                    style="color: #707070; text-align: right;"
                                                    :class="{ 'custom-input': true }" v-model="scope.row.rate"
                                                    @change="rateChange(scope.$index)" />
                                            </div>
                                        </el-table-column>
                                        <el-table-column label="Price (RM)" :min-width="100" align="center">
                                            <div v-if="scope.row.waste_type.name != 'Transportation rate' && scope.row.waste_type.name != 'GRAND TOTAL'"
                                                slot-scope="scope">
                                                <p
                                                    style="text-align: right; font-size: 14px; color: #707070; margin-right: 16%;">
                                                    {{ scope.row.amount }}
                                                </p>
                                            </div>
                                            <div v-else-if="scope.row.waste_type.name == 'Transportation rate'">

                                                <p v-if="positionid == 4 && pagestatus == 9"
                                                    style="text-align: right; font-size: 14px; color: #707070; margin-right: 16%;">
                                                    {{ transportrate }}
                                                </p>
                                                <p v-else-if="positionid != 4 && pagestatus == 9"
                                                    style="text-align: right; font-size: 14px; color: #707070; margin-right: 16%;">
                                                    {{ transportrate }}
                                                </p>
                                                <p v-else-if="positionid == 4"
                                                    style="text-align: right; font-size: 14px; color: #707070; margin-right: 16%;">
                                                    {{ transportrate }}
                                                </p>
                                                <p v-else-if="positionid != 4 && pagestatus == 100"
                                                    style=" font-size: 14px; color: #707070; text-align: right; margin-right: 16%;">
                                                    {{ transportrate }}
                                                </p>
                                                <input
                                                    v-else-if="positionid != 4 && pagestatus != 100 && pagestatus != 9"
                                                    slot-scope="scope" type="number" min="0" step=".01"
                                                    style="color: #707070; text-align: right;"
                                                    :class="{ 'custom-input': true }"
                                                    @input="transportrate = transportrate < 0 ? 0 : transportrate"
                                                    v-model="transportrate" />
                                            </div>
                                            <div v-else-if="scope.row.waste_type.name == 'GRAND TOTAL'"
                                                slot-scope="scope">
                                                <p v-if="positionid != 4"
                                                    style="text-align: right; margin-right: 16%; font-size: 14px; color: #707070">
                                                    {{ totalamount.toLocaleString() }}
                                                </p>
                                                <p v-else-if="positionid == 4"
                                                    style="text-align: right; margin-right: 16%; font-size: 14px; color: #707070">
                                                    {{ scope.row.amount }}
                                                </p>
                                            </div>
                                        </el-table-column>
                                    </el-table>
                                    <div class="row">
                                        <div class="col-4">

                                            <div
                                                v-if="(positionid != 4 && pagestatus == 9) || (positionid == 4 && pagestatus == 100) || (positionid != 4 && pagestatus == 100) || (positionid == 4 && pagestatus == 2)">
                                                <p
                                                    style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                    Delivery Term
                                                </p>
                                                <p
                                                    style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                                                    {{
                                                        deliveryterm }} {{
                                                        deliverytermunit }}
                                                </p>
                                                <br />
                                            </div>
                                        </div>
                                        <div class="col-4">
                                            <div
                                                v-if="(positionid != 4 && pagestatus == 9) || (positionid == 4 && pagestatus == 100) || (positionid != 4 && pagestatus == 100) || (positionid == 4 && pagestatus == 2)">
                                                <p
                                                    style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                    Payment Term
                                                </p>
                                                <p
                                                    style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                                                    {{
                                                        paymentterm }} <span
                                                        style="color: #707070; font-size: 14px;">Days</span>
                                                </p>
                                                <br />
                                            </div>
                                        </div>
                                        <div class="col-4">
                                            <div
                                                v-if="(positionid != 4 && pagestatus == 9) || (positionid == 4 && pagestatus == 100) || (positionid != 4 && pagestatus == 100) || (positionid == 4 && pagestatus == 2)">
                                                <p
                                                    style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                    Validity
                                                </p>
                                                <p
                                                    style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">
                                                    {{
                                                        validity }} <span
                                                        style="color: #707070; font-size: 14px;">Days</span>
                                                </p>
                                                <br />
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        v-if="(positionid != 4 && pagestatus == 9) || (positionid == 4 && pagestatus == 100) || (positionid != 4 && pagestatus == 100) || (positionid == 4 && pagestatus == 2)">
                                        <p
                                            style="color: #5A5A5A;opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                            Remarks
                                        </p>
                                        <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; ">{{
                                            remarks }}
                                        </p>
                                        <br />
                                    </div>

                                    <p
                                        style="color: #707070; font-size: 15px; font-weight: bold; text-align: left; margin-bottom: -10px;">
                                        Quotation Supporting Document
                                    </p>

                                    <div class="col-lg-12">
                                        <div v-if="allquotationdocs.length === 0">
                                            <p
                                                style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                No
                                                file
                                                uploaded.
                                            </p>
                                        </div>
                                        <div v-for="(item, index) in allquotationdocs" :key="index">
                                            <div class="row">
                                                <div class="col-lg-1 text-center">
                                                    <p style="color: #A5A5A5; font-size: 14px;">{{ index + 1 }}.</p>
                                                </div>
                                                <div class="col-lg-10 text-left">
                                                    <p style="color: #A5A5A5; font-size: 14px;">{{ item.filename }}</p>
                                                </div>
                                                <div class="col-lg-1 text-center">
                                                    <a :href="item.fileurl" :download="item.filename">
                                                        <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <p
                                        style="color: #707070; font-size: 15px; font-weight: bold; text-align: left; margin-bottom: -10px;">
                                        Proforma Invoice
                                    </p>
                                    <div class="col-lg-12">
                                        <div v-if="allproformafile.length === 0">
                                            <p
                                                style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                No
                                                file
                                                uploaded.
                                            </p>
                                        </div>
                                        <div v-for="(item, index) in allproformafile" :key="index">
                                            <div class="row">
                                                <div class="col-lg-1 text-center">
                                                    <p style="color: #A5A5A5; font-size: 14px;">{{ index + 1 }}.</p>
                                                </div>
                                                <div class="col-lg-10 text-left">
                                                    <p style="color: #A5A5A5; font-size: 14px;">{{ item.filename }}</p>
                                                </div>
                                                <div class="col-lg-1 text-center">
                                                    <a :href="item.fileurl" :download="item.filename">
                                                        <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <p
                                        style="color: #707070; font-size: 15px; font-weight: bold; text-align: left; margin-bottom: -10px;">
                                        Payment Receipt
                                    </p>
                                    <div class="col-lg-12">
                                        <div v-if="allpaymentproof.length === 0">
                                            <p
                                                style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                No
                                                file
                                                uploaded.
                                            </p>
                                        </div>
                                        <div v-for="(item, index) in allpaymentproof" :key="index">
                                            <div class="row">
                                                <div class="col-lg-1 text-center">
                                                    <p style="color: #A5A5A5; font-size: 14px;">{{ index + 1 }}.</p>
                                                </div>
                                                <div class="col-lg-10 text-left">
                                                    <p style="color: #A5A5A5; font-size: 14px;">{{ item.filename }}</p>
                                                </div>
                                                <div class="col-lg-1 text-center">
                                                    <a :href="item.fileurl" :download="item.filename">
                                                        <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <br />
                        </div>
                    </b-card>
                </modal>

                <modal :show.sync="modals.viewother" class="modal-eprf" centered>
                    <b-card class="card text-center" style="background-color: white; box-shadow: none"
                        border-variant="primary" header="ORDER DETAILS - " header-bg-variant="primary"
                        header-text-variant="white">
                        <template #header>
                            <div class="row">
                                <div class="col-lg text-left">
                                    <h4 class="mb-0">ORDER DETAILS - {{ referenceno }}</h4>
                                </div>
                                <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                                    <base-button class="btn-icon btn-cancel btn-round btn-sm">
                                        <i style="
                    transform: translate(-50%, -50%);
                    color: white;
                    font-weight: 900;
                    font-size: 12px;
                  " class="tim-icons icon-simple-remove" @click="modals.viewother = false"></i>
                                    </base-button>
                                </div>
                            </div>
                        </template>

                        <div class="col-lg-12">
                            <el-table :data="allorderitems" :header-cell-style="{
                                background: '#358DCC',
                                border: 'transparent',
                                'font-size': '14px',
                                'font-weight': '400',
                                color: '#FFFFFF',
                            }" :row-style="tableRowClassName">
                                <el-table-column width="100" align="center">
                                    <template slot="header" slot-scope="scope">
                                        <div><span>{{ scope.column.label }}</span></div>
                                    </template>
                                    <div slot-scope="scope">
                                        <p style="font-size: 14px; color: #707070">
                                            {{ scope.$index + 1 }}
                                        </p>
                                    </div>
                                </el-table-column>
                                <el-table-column label="Item" :min-width="150" prop="filename" align="left">
                                    <template slot="header" slot-scope="scope">
                                        <div><span>{{ scope.column.label }}</span>
                                        </div>
                                    </template>
                                    <div slot-scope="scope" align="left">
                                        <p style="font-size: 14px; color: #707070">
                                            {{ scope.row.waste_type.name }}
                                        </p>
                                    </div>
                                </el-table-column>
                                <el-table-column label="Quantity" :min-width="50" prop="filename" align="center">
                                    <template slot="header" slot-scope="scope">
                                        <div><span>{{ scope.column.label }}</span>
                                        </div>
                                    </template>
                                    <div slot-scope="scope" align="center">
                                        <p style="font-size: 14px; color: #707070">
                                            {{ scope.row.quantity }}
                                        </p>
                                    </div>
                                </el-table-column>
                                <!-- <el-table-column label="Remarks" :min-width="100" align="center">
                                    <div slot-scope="scope">
                                        <p v-if="scope.row.remark != ''"
                                            style="text-align: justify; font-size: 14px; color: #707070">
                                            {{ scope.row.remark }}
                                        </p>
                                        <p v-else style="text-align: justify; font-size: 14px; color: #707070">-</p>
                                    </div>
                                </el-table-column> -->
                            </el-table>

                            <div class="col-lg-12">
                                <div class="row">
                                    <div class="col-lg">
                                        <p
                                            style="color: #707070; opacity: 0.7;  text-align: left; font-size: 14px; margin-bottom: -10px;">
                                            Status
                                        </p>
                                        <p
                                            style="color: #5A5A5A;  opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px;">
                                            {{ statusname }}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <br />
                            <div class="col-lg-12">
                                <div class="row">
                                    <div class="col-lg">
                                        <p
                                            style="color: #707070; opacity: 0.7;  text-align: left; font-size: 14px; margin-bottom: -10px;">
                                            Pickup
                                            Location
                                        </p>
                                        <p
                                            style="color: #5A5A5A;  opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px;">
                                            {{
                                                servicelocation
                                            }}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <br />
                            <div class="col-lg-12">
                                <div class="row">
                                    <div class="col-lg">
                                        <p
                                            style="color: #707070; opacity: 0.7;  text-align: left; font-size: 14px; margin-bottom: -10px;">
                                            Customer Remark
                                        </p>
                                        <p
                                            style="color: #5A5A5A;  opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px;">
                                            {{
                                                customerremark
                                            }}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <br />
                            <!-- 99 quote disputed-->
                            <!-- 4 quotation disputed -->
                            <div v-if="currentstatus == 4" class="col-lg-12">
                                <div class="row">
                                    <div class="col-lg">
                                        <p
                                            style="color: #707070; opacity: 0.7;  text-align: left; font-size: 14px; margin-bottom: -10px;">
                                            Quotation Disputed Reason <span>
                                                <i @click="modals.viewlog = true" style="margin-top: -5px;"
                                                    class="tim-icons icon-chat-33 download-icon"></i>
                                            </span>
                                        </p>
                                        <p
                                            style="color: #5A5A5A;  opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px;">
                                            {{
                                                quotationdisputedreason
                                            }}
                                        </p>
                                    </div>
                                </div>
                                <br />
                                <p
                                    style="color: #707070; font-size: 15px; font-weight: bold; text-align: left; margin-bottom: -10px;">
                                    Quotation Dispute Document
                                </p>

                                <div class="col-lg-12">
                                    <div v-if="allquotationdisputedocs.length === 0">
                                        <p
                                            style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                            No
                                            file
                                            uploaded.
                                        </p>
                                    </div>
                                    <div v-for="(item, index) in allquotationdisputedocs" :key="index">
                                        <div class="row">
                                            <div class="col-lg-1 text-center">
                                                <p style="color: #A5A5A5; font-size: 14px;">{{ index + 1 }}.</p>
                                            </div>
                                            <div class="col-lg-10 text-left">
                                                <p style="color: #A5A5A5; font-size: 14px;">{{ item.filename }}</p>
                                            </div>
                                            <div class="col-lg-1 text-center">
                                                <a :href="item.fileurl" :download="item.filename">
                                                    <i class="tim-icons icon-cloud-download-93 download-icon"></i>

                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="currentstatus == 99" class="col-lg-12">
                                <div class="row">
                                    <div class="col-lg">
                                        <p
                                            style="color: #707070; opacity: 0.7;  text-align: left; font-size: 14px; margin-bottom: -10px;">
                                            Quote Disputed Reason
                                        </p>
                                        <p
                                            style="color: #5A5A5A;  opacity: 0.78; font-weight: bold; text-align: left; font-size: 14px;">
                                            {{
                                                quotedisputedreason
                                            }}
                                        </p>
                                    </div>
                                </div>
                                <br />
                                <p
                                    style="color: #707070; font-size: 15px; font-weight: bold; text-align: left; margin-bottom: -10px;">
                                    Quote Dispute Document
                                </p>

                                <div class="col-lg-12">
                                    <div v-if="allquotedisputedocs.length === 0">
                                        <p
                                            style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                            No
                                            file
                                            uploaded.
                                        </p>
                                    </div>
                                    <div v-for="(item, index) in allquotedisputedocs" :key="index">
                                        <div class="row">
                                            <div class="col-lg-1 text-center">
                                                <p style="color: #A5A5A5; font-size: 14px;">{{ index + 1 }}.</p>
                                            </div>
                                            <div class="col-lg-10 text-left">
                                                <p style="color: #A5A5A5; font-size: 14px;">{{ item.filename }}</p>
                                            </div>
                                            <div class="col-lg-1 text-center">
                                                <a :href="item.fileurl" :download="item.filename">
                                                    <i class="tim-icons icon-cloud-download-93 download-icon"></i>

                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <br />
                        </div>
                    </b-card>
                </modal>

                <modal :show.sync="modals.viewlog" class="modal-eprf" centered>
                    <b-card class="card text-center" style="background-color: white; box-shadow: none"
                        border-variant="primary" header="DISPUTE LOG" header-bg-variant="primary"
                        header-text-variant="white">
                        <template #header>
                            <div class="row">
                                <div class="col-lg text-left">
                                    <h4 class="mb-0">DISPUTE LOG</h4>
                                </div>
                                <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                                    <base-button class="btn-icon btn-cancel btn-round btn-sm">
                                        <i style="
                    transform: translate(-50%, -50%);
                    color: white;
                    font-weight: 900;
                    font-size: 12px;
                  " class="tim-icons icon-simple-remove" @click="modals.viewlog = false"></i>
                                    </base-button>
                                </div>
                            </div>
                        </template>

                        <div class="col-lg-12">
                            <el-table :data="logquotationdisputed" :header-cell-style="{
                                background: '#358DCC',
                                border: 'transparent',
                                'font-size': '14px',
                                'font-weight': '400',
                                color: '#FFFFFF',
                            }" :row-style="tableRowClassName">
                                <el-table-column width="100" align="center">
                                    <template slot="header" slot-scope="scope">
                                        <div><span>{{ scope.column.label }}</span></div>
                                    </template>
                                    <div slot-scope="scope">
                                        <p style="font-size: 14px; color: #707070">
                                            {{ scope.$index + 1 }}
                                        </p>
                                    </div>
                                </el-table-column>
                                <el-table-column label="Reason" :min-width="150" prop="remark" align="center">
                                </el-table-column>
                                <el-table-column label="Date Created" :min-width="50" prop="date" align="center">
                                </el-table-column>
                                <el-table-column label="PIC" :min-width="50" prop="username" align="center">
                                </el-table-column>
                            </el-table>
                        </div>
                    </b-card>
                </modal>

                <modal :show.sync="modals.viewproforma" class="modal-eprf" centered>
                    <b-card class="card text-center" style="background-color: #f5f6fa; box-shadow: none"
                        border-variant="primary" header="PAYMENT RECEIPT" header-bg-variant="primary"
                        header-text-variant="white">
                        <template #header>
                            <div class="row">
                                <div class="col-lg text-left">
                                    <h4 class="mb-0">PAYMENT RECEIPT</h4>
                                </div>
                                <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                                    <base-button class="btn-icon btn-cancel btn-round btn-sm">
                                        <i style="
                    transform: translate(-50%, -50%);
                    color: white;
                    font-weight: 900;
                    font-size: 12px;
                  " class="tim-icons icon-simple-remove" @click="modals.viewproforma = false"></i>
                                    </base-button>
                                </div>
                            </div>
                        </template>
                        <div class="col-lg-12">
                            <div class="modal-body-scrollable" style="max-height: 70vh; overflow-y: auto;">

                                <div style="padding: 5px 20px 0px 20px;">
                                    <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                                        Quotation document
                                    </p>

                                    <div class="col-lg-12">
                                        <div v-if="allquotationdocs.length === 0">
                                            <p
                                                style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                                                No
                                                file
                                                chosen
                                            </p>
                                        </div>
                                        <div v-for="(item, index) in allquotationdocs" :key="index">
                                            <div class="row">
                                                <div class="col-lg-1 text-center">
                                                    <p style="color: #A5A5A5; font-size: 14px;">{{ index + 1 }}.</p>
                                                </div>
                                                <div class="col-lg-10 text-left">
                                                    <p style="color: #A5A5A5; font-size: 14px;">{{ item.filename }}</p>
                                                </div>
                                                <div class="col-lg-1 text-center">
                                                    <a :href="item.fileurl" :download="item.filename">
                                                        <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div v-if="allproformafile.length !== 0"> -->
                                    <br />

                                    <p
                                        style="color: #707070; font-size: 15px; font-weight: bold; text-align: left; margin-bottom: -10px;">
                                        Upload Proforma Invoice<span style="color: #EC1B23">*</span>
                                    </p>
                                    <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">Please
                                        upload proforma invoice
                                    </p>

                                    <div class="row">
                                        <div class="col-lg-4 text-left">
                                            <div class="fileinput">
                                                <label style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                " for="proof-upload" type="primary" class="btn">
                                                    Choose File
                                                </label>

                                                <div class="d-flex justify-content-center spinner"
                                                    v-if="uploadload == true">
                                                    <circle-8></circle-8>
                                                </div>

                                                <input accept="application/pdf" id="proof-upload" ref="proforma"
                                                    type="file" name="..." class="valid" :multiple="true"
                                                    aria-invalid="false" style="display: none"
                                                    v-on:change="onFileChangeProforma" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-12">
                                        <div v-if="allproformafile.length === 0">
                                            <p
                                                style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px; margin-bottom: -10px;">
                                                No
                                                file
                                                chosen
                                            </p>
                                        </div>
                                        <div v-for="(item, index) in allproformafile" :key="index">
                                            <div class="row">
                                                <div class="col-lg-1 text-center">
                                                    <p style="color: #A5A5A5; font-size: 14px;">{{ index + 1 }}.</p>
                                                </div>
                                                <div class="col-lg-9 text-left">
                                                    <p style="color: #A5A5A5; font-size: 14px;">{{ item.filename }}</p>
                                                </div>
                                                <div class="col-lg-1 text-center">
                                                    <a :href="item.fileurl" :download="item.filename">
                                                        <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                                                    </a>
                                                </div>
                                                <div class="col-lg-1 text-center">
                                                    <i style="
                            cursor: pointer;
                    color: #FF0000;
                    font-weight: 900;
                    font-size: 20px;
                    margin-top: 16px;
                  " class="tim-icons icon-simple-remove" @click="removeProforma(item.fileid)"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <base-button type="primary" @click="submitProforma()"
                                            :disabled="cansubmitproforma">Submit</base-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-card>
                </modal>

                <modal :show.sync="modals.disputereason" class="modal-eprf" centered>
                    <b-card class="card text-center" style="background-color: #f5f6fa; box-shadow: none"
                        border-variant="primary" header="REASON FOR DISPUTE" header-bg-variant="primary"
                        header-text-variant="white">
                        <template #header>
                            <div class="row">
                                <div class="col-lg text-left">
                                    <h4 class="mb-0">REASON FOR DISPUTE</h4>
                                </div>
                                <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                                    <base-button class="btn-icon btn-cancel btn-round btn-sm">
                                        <i style="
                            transform: translate(-50%, -50%);
                            color: white;
                            font-weight: 900;
                            font-size: 12px;
                            " class="tim-icons icon-simple-remove" @click="modals.disputereason = false"></i>
                                    </base-button>
                                </div>
                            </div>
                        </template>

                        <div class="row">
                            <div class="col-lg-12">
                                <textarea style="border: 1px solid #aaa; background-color: white" type="textarea"
                                    placeholder="Reason for dispute quotation..." v-model="reason"
                                    :class="{ textarea: true }"></textarea>
                            </div>
                        </div>

                        <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                            Quotation Dispute document
                        </p>

                        <div class="col-lg-12">
                            <div v-if="allquotationdisputedocs.length === 0">
                                <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                                    No
                                    file
                                    chosen
                                </p>
                            </div>
                            <div v-else-if="allquotationdisputedocs.length >= 1"
                                v-for="(item, index) in allquotationdisputedocs" :key="index">
                                <div class="row">
                                    <div class="col-lg-1 text-center">
                                        <p style="color: #A5A5A5; font-size: 14px;">{{ index + 1 }}.</p>
                                    </div>
                                    <div class="col-lg-9 text-left">
                                        <p style="color: #A5A5A5; font-size: 14px;">{{ item.filename }}</p>
                                    </div>
                                    <div class="col-lg-1 text-center">
                                        <a :href="item.fileurl" :download="item.filename">
                                            <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                                        </a>
                                    </div>
                                    <div class="col-lg-1 text-center">
                                        <i style="
                            cursor: pointer;
                    color: #FF0000;
                    font-weight: 900;
                    font-size: 20px;
                    margin-top: 16px;
                  " class="tim-icons icon-simple-remove" @click="removeDisputeQuotationdocs(item.fileid)"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div class="row">
                            <div class="col-lg-1">
                                <div class="fileinput">
                                    <label style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                " for="quotation-dispute-upload" type="primary" class="btn">
                                        Upload
                                    </label>

                                    <div class="d-flex justify-content-center spinner" v-if="this.uploadload == true">
                                        <circle-8></circle-8>
                                    </div>

                                    <input accept="application/pdf" id="quotation-dispute-upload" type="file" name="..."
                                        class="valid" :multiple="true" aria-invalid="false" style="display: none"
                                        v-on:change="onFileChangeDisputeQuotationdocs" />
                                </div>
                            </div>

                            <div class="col-lg"></div>

                            <div class="col-lg-4 text-right">
                                <base-button type="primary" :disabled="candispute"
                                    v-on:click="disputeQuotation()">Submit</base-button>
                            </div>
                        </div>
                    </b-card>
                </modal>

                <modal :show.sync="modals.picdisputereason" class="modal-eprf" centered>
                    <b-card class="card text-center" style="background-color: #f5f6fa; box-shadow: none"
                        border-variant="primary" header="REASON FOR DISPUTE" header-bg-variant="primary"
                        header-text-variant="white">
                        <template #header>
                            <div class="row">
                                <div class="col-lg text-left">
                                    <h4 class="mb-0">REASON FOR DISPUTE</h4>
                                </div>
                                <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                                    <base-button class="btn-icon btn-cancel btn-round btn-sm">
                                        <i style="
                    transform: translate(-50%, -50%);
                    color: white;
                    font-weight: 900;
                    font-size: 12px;
                  " class="tim-icons icon-simple-remove" @click="modals.picdisputereason = false"></i>
                                    </base-button>
                                </div>
                            </div>
                        </template>

                        <div class="row">
                            <div class="col-lg-12">
                                <textarea style="border: 1px solid #aaa; background-color: white;" type="textarea"
                                    placeholder="Reason for rejection..." v-model="disputereason"
                                    :class="{ textarea: true }"></textarea>
                            </div>
                        </div>

                        <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                            Quote Dispute document
                        </p>

                        <div class="col-lg-12">
                            <div v-if="allquotedisputedocs.length === 0">
                                <p style="color: #707070;  opacity: 0.7; text-align: left; font-size: 14px;">
                                    No
                                    file
                                    chosen
                                </p>
                            </div>
                            <div v-else-if="allquotedisputedocs.length >= 1"
                                v-for="(item, index) in allquotedisputedocs" :key="index">
                                <div class="row">
                                    <div class="col-lg-1 text-center">
                                        <p style="color: #A5A5A5; font-size: 14px;">{{ index + 1 }}.</p>
                                    </div>
                                    <div class="col-lg-9 text-left">
                                        <p style="color: #A5A5A5; font-size: 14px;">{{ item.filename }}</p>
                                    </div>
                                    <div class="col-lg-1 text-center">
                                        <a :href="item.fileurl" :download="item.filename">
                                            <i class="tim-icons icon-cloud-download-93 download-icon"></i>
                                        </a>
                                    </div>
                                    <div class="col-lg-1 text-center">
                                        <i style="
                            cursor: pointer;
                    color: #FF0000;
                    font-weight: 900;
                    font-size: 20px;
                    margin-top: 16px;
                  " class="tim-icons icon-simple-remove" @click="removeDisputeQuotedocs(item.fileid)"></i>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-1">
                                <div class="fileinput">
                                    <label style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                " for="quote-dispute-upload" type="primary" class="btn">
                                        Upload
                                    </label>

                                    <div class="d-flex justify-content-center spinner" v-if="this.uploadload == true">
                                        <circle-8></circle-8>
                                    </div>

                                    <input accept="application/pdf" id="quote-dispute-upload" type="file" name="..."
                                        class="valid" :multiple="true" aria-invalid="false" style="display: none"
                                        v-on:change="onFileChangeDisputeQuotedocs" />
                                </div>
                            </div>

                            <div class="col-lg"></div>

                            <div class="col-lg-4 text-right">
                                <base-button type="primary" :disabled="cansubmitdispute"
                                    v-on:click="disputeQuote()">Submit</base-button>
                            </div>
                        </div>
                    </b-card>
                </modal>

                <StatusModal :show.sync="modals.successModal" :message="modal.success" :title="modal.successTitle" />
                <StatusModal :show.sync="modals.removeModal" :message="modal.remove" :title="modal.removeTitle" />
                <StatusModal :show.sync="modals.removeFailedModal" :message="modal.removeFailed"
                    :title="modal.removeTitle" />

                <div class="col-lg-2 text-left">
                    <el-select placeholder="Select status" v-model="selects.status" @change="getData()" filterable>
                        <el-option v-for="option in selects.statuses" class="select-info custom-option"
                            :value="option.value" :label="option.label" :key="option.value"></el-option>
                    </el-select>
                </div>
                <div class="col-lg"></div>
                <div class="col-lg-2">
                    <el-input type="search" class="mb-3 search-input" prefix-icon="el-icon-search"
                        placeholder="Search Ref No, Comp..." v-model="search" aria-controls="datatables"></el-input>
                </div>
            </div>
        </div>
        <div class="col-lg-12">
            <div class="row">
                <div class="col-lg-12">
                    <card class="card-eprf">
                        <div id="tableku" v-if="!load">
                            <el-table :data="queriedData" style="width: 100%; color: #A5A5A5" height="700"
                                :header-cell-style="{
                                    background: 'transparent',
                                    color: 'black',
                                }" class="custom-table" @row-click="clickRow" :row-class-name="rowHover">
                                <el-table-column :min-width="50" align="center" prop="index" label="NO">
                                </el-table-column>
                                <el-table-column :min-width="150" align="center" prop="refno" label="REFERENCE NO">
                                    <template slot-scope="{ row }">
                                        <p class="job-no-title" style="color: #358CCB">
                                            {{ row.refno }}
                                        </p>
                                    </template>
                                </el-table-column>
                                <el-table-column :min-width="150" align="center" prop="companyname"
                                    label="COMPANY NAME">
                                </el-table-column>
                                <!-- <el-table-column :min-width="150" sortable align="center" prop="requestdate" -->
                                <!-- label="REQUEST DATE"></el-table-column> -->
                                <el-table-column :min-width="150" sortable align="center" prop="requestdate"
                                    label="REQUEST DATE">
                                    <template slot-scope="{row}">
                                        {{ moment(row.requestdate).format("DD-MM-YYYY") }}
                                    </template>
                                </el-table-column>
                                <el-table-column :min-width="150" align="center" prop="status" label="STATUS">
                                    <template slot-scope="{ row }">
                                        <p :style="{ color: row.statuscolour }" class="statusview">
                                            {{ row.status }}
                                        </p>
                                        <!-- <p> {{ row.statusid }}</p> -->
                                    </template>
                                </el-table-column>
                                <el-table-column :min-width="150" align="center" prop="deliverytype"
                                    label="DELIVERY TYPE">
                                </el-table-column>
                                <el-table-column :min-width="300" align="center" prop="remarks" label="REMARKS">
                                    <template slot-scope="{ row }">
                                        <p style="color: #A5A5A5; text-align: center;"
                                            v-if="!row.remarks || row.remarks.trim() === ''">
                                            -
                                        </p>
                                        <p style="color: #A5A5A5; text-align: center;" v-else>
                                            {{ row.remarks }}
                                        </p>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="d-flex justify-content-center spinner" v-else>
                            <circle-8></circle-8>
                        </div>
                    </card>
                    <div slot="footer"
                        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <el-select v-model="pagination.perPage" placeholder="Per page">
                            <el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item"
                                :label="item" :value="item"></el-option>
                        </el-select>

                        <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
                            :per-page="pagination.perPage" :total="pagination.total"></base-pagination>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {
    Alert,
    Select,
    Option,
    DatePicker,
    Table,
    TableColumn,
} from "element-ui";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";
import util from "../../../util/util";
import Card from "../../../components/Cards/Card.vue";
import {
    Modal,
    ImageUpload,
    BasePagination,
    BaseSwitch,
} from "../../../../src/components";
import moment from "moment";
import Fuse from "fuse.js";
import { debounce } from "src/util/debounce";
import DashboardLayout from "../../Layout/DashboardLayout.vue";
import DashboardNavbar from "../../Layout/DashboardNavbar.vue";
import StatusModal from 'src/components/StatusModal.vue';
import { modal } from "src/components/variable.js";
import { ModalPlugin } from "bootstrap-vue";
import { BCard } from "bootstrap-vue";
import { getStorage } from "../../../util/storage";
import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";

export default {
    name: "Sales",

    components: {
        DashboardLayout,
        DashboardNavbar,
        Card,
        Modal,
        ImageUpload,
        [DatePicker.name]: DatePicker,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        BasePagination,
        BaseSwitch,
        Circle8,
        [Select.name]: Select,
        [Option.name]: Option,
        StatusModal,
        BCard,
    },


    data() {
        return {
            companyname: '-',
            companyphoneno: '-',
            companyaddress: '',
            companyemail: '-',
            pdftable: [],
            quotationdisputedreason: '',
            logquotationdisputed: [],
            quotedisputedreason: '',
            totalamount: 0,
            transportrate: 0.00,
            oldrate: 0,
            pagestatus: 0,
            statusname: '-',
            disputereason: '',
            disputedocs: null,
            allInvoice: [],
            selects: {
                day: "Days",
                days: [
                    {
                        label: "Days",
                        value: "Days",
                    },
                    {
                        label: "Working Days",
                        value: "Working Days",
                    },
                ],
                payment: "Days",
                payments: [
                    {
                        label: "Days",
                        value: "Days",
                    },
                    {
                        label: "Working Days",
                        value: "Working Days",
                    },
                ],
                validity: "Days",
                validities: [
                    {
                        label: "Days",
                        value: "Days",
                    },
                    {
                        label: "Working Days",
                        value: "Working Days",
                    },
                ],
                status: "",
                statuses: [],
            },
            modals: {
                viewlog: false,
                disputereason: false,
                viewupdatequotation: false,
                viewquotation: false,
                viewdeliveryorder: false,
                viewother: false,
                viewproforma: false,
                successModal: false,
                removeModal: false,
                removeFailedModal: false,
                picdisputereason: false,
            },

            proof: null,
            proforma: null,
            roleid: 0,
            path: '',
            currentsaleid: '',
            currentstatus: '',
            modal: modal,

            allquotationdocs: [],
            allpaymentproof: [],
            allproformafile: [],
            allquotationdisputedocs: [],
            allquotedisputedocs: [],

            orderstatus: 'Order ready to be pick up',
            pickuplocation: 'Cyberjaya',
            reason: "",
            newdate: "",

            tableDatas: [
            ],

            temp: [
            ],

            allorderitems: [
                {
                    orderid: "2bcc1e04-c002-443c-86b3-4ec76d9f4c22",
                    quantity: 9,
                    rate: 10.3,
                    rate_cent: 0,
                    remark: "ko",
                    waste_type: {
                        waste_type_id: 18,
                        name: "Category Y substance"
                    }
                },
                {
                    orderid: "53d4642a-0e63-4d00-9176-b031e2df7995",
                    quantity: 9,
                    rate: 90.8,
                    rate_cent: 0,
                    remark: "ok",
                    waste_type: {
                        waste_type_id: 11,
                        name: "Oily bilge water"
                    }
                }
            ],

            referenceno: "",
            subjectline: "",
            servicelocation: "-",
            customerremark: "",
            deliverytermunit: "",
            paymentterm: "",
            paymenttermunit: "",
            validityuniy: "",
            disputedreason: "-",

            load: false,

            jobno: [
                {
                    prop: "jobno",
                    label: "REFERENCE NO",
                },
            ],

            requestdate: [
                {
                    prop: "requestdate",
                    label: "REQUEST DATE",
                },
            ],

            customer: [
                {
                    prop: "customer",
                    label: "CUSTOMER",
                },
            ],

            status: [
                {
                    prop: "status",
                    label: "STATUS",
                },
            ],

            remarks: [
                {
                    prop: "remarks",
                    label: "REMARKS",
                },
            ],

            edit: [
                {
                    prop: "edit",
                    label: "EDIT",
                },
            ],

            delete: [
                {
                    prop: "delete",
                    label: "DELETE",
                },
            ],

            selectedJobNo: '',
            picname: '',
            picphoneno: '',
            picemail: '-',
            deliveryterm: '',
            validity: '',

            product: [

                {
                    jobno: 'OBQ849368',
                    name: "Recon Oil",
                    quantity: 300,
                    rate: 20,
                    transportrate: 0,
                    productremarks: "None",
                    price: 600

                },
                {
                    jobno: 'OBQ849368',
                    name: "Raw Oil",
                    quantity: 300,
                    rate: 20,
                    transportrate: 0,
                    productremarks: "None",
                    price: 600

                },
                {
                    jobno: 'OBQ849368',
                    name: "Parrafin Wax",
                    quantity: 200,
                    rate: 20,
                    transportrate: 0,
                    productremarks: "None",
                    price: 600
                },
                {
                    jobno: 'OBQ987464',
                    name: "Parrafin Wax",
                    quantity: 100,
                    rate: 30,
                    transportrate: 0,
                    productremarks: "None",
                    price: 700
                }
            ],

            name: [
                {
                    prop: "name",
                    label: "Product"
                }
            ],

            quantity: [
                {
                    prop: "quantity",
                    label: "Quantity (KG)"
                }
            ],

            rate: [
                {
                    prop: "rate",
                    label: "Rate (KG)"
                }
            ],

            productremarks: [
                {
                    prop: "productremarks",
                    label: "Remarks"
                }
            ],

            price: [
                {
                    prop: "price",
                    label: "Price (RM)"
                }
            ],

            search: '',
            searchQuery: "",
            searchedData: [],
            fuseSearch: null,
            currentRow: "",
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [10, 25, 50],
                total: 0,
            },
            filepath: "",
            flag: false,
            page: 1,

            documentID: [],
            uploadproofofpayment: false,
            uploadload: false,
            positionid: 0,

        };
    },

    methods: {
        async getPDF() {
            this.pdftable = [];

            await this.$http
                .get(":10001/api/v1/shop/quote/" + this.currentsaleid)
                .then((res) => {
                    if (!res.error) {
                        let response = res.message;

                        let ratee;
                        let estamtt;
                        let amt;
                        let amountt = 0;
                        let totalamount = 0;

                        let formatter = new Intl.NumberFormat("en-US");

                        for (var i = 0; i < response.order.length; i++) {
                            ratee = parseFloat(response.order[i].rate).toFixed(2);
                            estamtt = response.order[i].quantity;
                            amt = ratee * estamtt;
                            totalamount += amt;
                            let obj = {
                                no: i + 1,
                                desc:
                                    response.order[i].waste_type.name,
                                rate: formatter.format(ratee),
                                estamt:
                                    response.order[i].quantity,
                                amt: amt,
                            };
                            amountt += amt;
                            this.pdftable.push(obj);
                        }

                        let transport = {
                            no: '',
                            desc: 'Tranportation Rate',
                            rate: '',
                            estamt: '',
                            amt: this.transportrate,
                        };

                        this.pdftable.push(transport);

                        let grandtotal = {
                            no: '',
                            desc: 'Grand Total',
                            rate: '',
                            estamt: '',
                            amt: totalamount.toFixed(2),
                        };

                        this.pdftable.push(grandtotal);



                    }
                });
        },
        async createDO() {
            await this.getPDF();
            let doc = jsPDF({
                orientation: "potrait",
            });

            const logo = new Image();
            logo.src = require("@/assets/img/afesnew.png");
            logo.onload = () => {
                this.options = Object.assign({}, this.options, {
                    logo: {
                        logo,
                    },
                });
            };

            const sign = new Image();
            sign.src = require("@/assets/img/autograph.png");
            sign.onload = () => {
                this.options = Object.assign({}, this.options, {
                    sign: {
                        sign,
                    },
                });
            };

            const data = this.pdftable;

            const columns = [
                "No.",
                "\t\t\t\t\tProduct",
                "Qty (Kg)",
                "Rate (RM/Kg)",
                "Price (RM)"
            ];

            const rows = data.map((obj) => [
                obj.no,
                obj.desc,
                obj.estamt,
                obj.rate,
                obj.amt,
            ]);

            doc.addImage(
                logo,
                "PNG",
                doc.internal.pageSize.getWidth() - 75,
                5,
                50,
                18.75
            );

            doc.setFontSize(21);
            doc.setFontStyle("bold");
            doc.text("DELIVERY ORDER", 15, 25);
            doc.setFontSize(11);

            doc.setLineWidth(0.3);
            doc.line(10, 40, doc.internal.pageSize.getWidth() - 10, 40);

            doc.setFontStyle("bold");

            doc.text(this.picname, 15, 55);

            doc.setFontStyle("normal");

            var companyAddress = this.companyaddress;
            var maxCharactersPerLine = 25;

            function splitTextIntoLines(text, maxLength) {
                var lines = [];
                while (text.length > maxLength) {
                    var line = text.substring(0, maxLength);
                    var lastSpace = line.lastIndexOf(" ");
                    if (lastSpace !== -1) {
                        lines.push(line.substring(0, lastSpace));
                        text = text.substring(lastSpace + 1);
                    } else {
                        lines.push(line);
                        text = text.substring(maxLength);
                    }
                }
                lines.push(text);
                return lines;
            }

            var addressLines = splitTextIntoLines(
                companyAddress,
                maxCharactersPerLine
            );

            for (var i = 0; i < addressLines.length; i++) {
                var yPos = 60 + i * 5;
                doc.text(addressLines[i], 15, yPos);
            }

            doc.setFontStyle("bold");
            doc.text("Ref No.", 130, 55);
            doc.text("Date", 130, 60);
            doc.setFontStyle("normal");

            doc.text(":", 150, 55);
            doc.text(":", 150, 60);

            doc.text(this.referenceno, 152, 55);
            doc.text(moment().format("DD-MM-YYYY"), 152, 60);

            doc.text("Tel No. : " + this.picphoneno, 15, 80);
            doc.text("Email : " + this.companyemail, 130, 80);
            doc.setFontStyle("bold");

            doc.text("Attention", 15, 90);
            doc.text("Subject", 15, 95);

            doc.text(":", 35, 90);
            doc.text(":", 35, 95);

            doc.text(this.picname, 40, 90);
            doc.text(this.subjectline, 40, 95);

            doc.setFontStyle("normal");

            doc.text("Dear Sir/Madam,", 15, 105);
            doc.text(
                "We appreciate this opportunity to offer you our delivery order as follows:",
                15,
                115
            );

            const table = doc.autoTable({
                head: [columns],
                columnStyles: {
                    0: {
                        halign: "center",
                        cellWidth: 10,
                    },
                    1: {
                        // columnWidth: 100,
                    },
                    2: {
                        halign: "center",
                        cellWidth: 20,
                    },
                    3: {
                        halign: "center",
                        cellWidth: 27,
                    },
                    4: {
                        halign: "center",
                        cellWidth: 23,
                    },
                },
                styles: {
                    lineWidth: 0.1, // Set the border line width
                    lineColor: [0, 0, 0], // Set the border color
                },
                theme: "plain",
                body: rows,
                startY: 120,
            });

            const tableHeight = table.autoTable.previous.finalY;

            doc.text("Terms & Conditions", 15, tableHeight + 10);
            doc.text("Terms of Delivery", 15, tableHeight + 15);
            doc.text("Terms of Payment", 15, tableHeight + 20);
            doc.text("Validity", 15, tableHeight + 25);
            doc.text("Remarks", 15, tableHeight + 30);

            doc.text(":", 55, tableHeight + 15);
            doc.text(":", 55, tableHeight + 20);
            doc.text(":", 55, tableHeight + 25);
            doc.text(": ", 55, tableHeight + 30);

            doc.text(
                "a) Payment for completed services to be paid and made payable to",
                60,
                tableHeight + 30
            );
            doc.setFontStyle("bold");

            doc.text(
                "ALAM FLORA ENVIRONMENTAL SOLUTIONS SDN BHD.",
                60,
                tableHeight + 35
            );
            doc.setFontStyle("normal");
            doc.text(
                "b) All price(s) quoted is inclusive of Sales and Services Tax (SST), customs",
                60,
                tableHeight + 40
            );
            doc.text(
                "clerance or taxes and customs agent fees (if any).",
                60,
                tableHeight + 45
            );

            doc.text(
                this.deliveryterm + " " + this.deliverytermunit,
                60,
                tableHeight + 15
            );
            doc.text(this.paymentterm + " Days", 60, tableHeight + 20);
            doc.text(this.validity + " Days", 60, tableHeight + 25);
            var text = this.remarks;
            var x = 60;
            var y = tableHeight + 50;

            var lines = doc.splitTextToSize(
                text,
                doc.internal.pageSize.width - x * 1.3
            );

            if (this.remarks != "" && this.remarks != null) {
                doc.text("c) " + lines[0], x, y);
            }
            for (var i = 1; i < lines.length; i++) {
                if (y + 50 > doc.internal.pageSize.getHeight() - 20) {
                    doc.addPage();
                    y = 25;
                }
                doc.text(lines[i], x, y + 5);
                y += 5;
            }

            var finalYOfText = y;

            doc.text(
                "If you agree with the quotation, please sign in below and send/email it to us as attached as soon as",
                15,
                finalYOfText + 10
            );

            doc.text("possible for further arrangement.", 15, finalYOfText + 15);
            doc.text(
                "Should you need any clarification, please contact " +
                this.companyname +
                " at " +
                this.companyphoneno,
                15,
                finalYOfText + 20
            );
            doc.setFontStyle("bold");

            doc.text(
                "for ALAM FLORA ENVIRONMENTAL SOLUTIONS SDN BHD",
                15,
                finalYOfText + 30
            );
            doc.setFontStyle("normal");

            doc.text(
                "Previously known as DRB-HICOM ENVIRONMENTAL SERVICES SDN BHD",
                15,
                finalYOfText + 35
            );

            doc.setFontStyle("bold");

            doc.addImage(
                sign,
                "PNG",
                doc.internal.pageSize.getWidth() - 195,
                finalYOfText + 40,
                30,
                15
            );

            doc.text("NAZIRA MAHAYUDDIN", 15, finalYOfText + 60);

            doc.setFontStyle("normal");
            doc.text("Senior Manager,", 15, finalYOfText + 65);
            doc.text("Marine Waste Management,", 15, finalYOfText + 70);
            doc.text(
                "Environmental Technology & Solutions Department",
                15,
                finalYOfText + 75
            );

            doc.save("Delivery Order.pdf");

            console.log("pdf createdd");
        },
        async createQuo() {
            await this.getPDF();
            let doc = jsPDF({
                orientation: "potrait",
            });

            const logo = new Image();
            logo.src = require("@/assets/img/afesnew.png");
            logo.onload = () => {
                this.options = Object.assign({}, this.options, {
                    logo: {
                        logo,
                    },
                });
            };

            const sign = new Image();
            sign.src = require("@/assets/img/autograph.png");
            sign.onload = () => {
                this.options = Object.assign({}, this.options, {
                    sign: {
                        sign,
                    },
                });
            };

            const data = this.pdftable;

            const columns = [
                "No.",
                "\t\t\t\t\tProduct",
                "Qty (Kg)",
                "Rate (RM/Kg)",
                "Price (RM)"
            ];

            const rows = data.map((obj) => [
                obj.no,
                obj.desc,
                obj.estamt,
                obj.rate,
                obj.amt,
            ]);

            doc.addImage(
                logo,
                "PNG",
                doc.internal.pageSize.getWidth() - 75,
                5,
                50,
                18.75
            );

            doc.setFontSize(21);
            doc.setFontStyle("bold");
            doc.text("QUOTATION", 15, 25);
            doc.setFontSize(11);

            doc.setLineWidth(0.3);
            doc.line(10, 40, doc.internal.pageSize.getWidth() - 10, 40);

            doc.setFontStyle("bold");

            doc.text(this.picname, 15, 55);

            doc.setFontStyle("normal");

            var companyAddress = this.companyaddress;
            var maxCharactersPerLine = 25;

            function splitTextIntoLines(text, maxLength) {
                var lines = [];
                while (text.length > maxLength) {
                    var line = text.substring(0, maxLength);
                    var lastSpace = line.lastIndexOf(" ");
                    if (lastSpace !== -1) {
                        lines.push(line.substring(0, lastSpace));
                        text = text.substring(lastSpace + 1);
                    } else {
                        lines.push(line);
                        text = text.substring(maxLength);
                    }
                }
                lines.push(text);
                return lines;
            }

            var addressLines = splitTextIntoLines(
                companyAddress,
                maxCharactersPerLine
            );

            for (var i = 0; i < addressLines.length; i++) {
                var yPos = 60 + i * 5;
                doc.text(addressLines[i], 15, yPos);
            }

            doc.setFontStyle("bold");
            doc.text("Ref No.", 130, 55);
            doc.text("Date", 130, 60);
            doc.setFontStyle("normal");

            doc.text(":", 150, 55);
            doc.text(":", 150, 60);

            doc.text(this.referenceno, 152, 55);
            doc.text(moment().format("DD-MM-YYYY"), 152, 60);

            doc.text("Tel No. : " + this.picphoneno, 15, 80);
            doc.text("Email : " + this.companyemail, 130, 80);
            doc.setFontStyle("bold");

            doc.text("Attention", 15, 90);
            doc.text("Subject", 15, 95);

            doc.text(":", 35, 90);
            doc.text(":", 35, 95);

            doc.text(this.picname, 40, 90);
            doc.text(this.subjectline, 40, 95);

            doc.setFontStyle("normal");

            doc.text("Dear Sir/Madam,", 15, 105);
            doc.text(
                "We appreciate this opportunity to offer you our quotation as follows:",
                15,
                115
            );

            const table = doc.autoTable({
                head: [columns],
                columnStyles: {
                    0: {
                        halign: "center",
                        cellWidth: 10,
                    },
                    1: {
                        // columnWidth: 100,
                    },
                    2: {
                        halign: "center",
                        cellWidth: 20,
                    },
                    3: {
                        halign: "center",
                        cellWidth: 27,
                    },
                    4: {
                        halign: "center",
                        cellWidth: 23,
                    },
                },
                styles: {
                    lineWidth: 0.1, // Set the border line width
                    lineColor: [0, 0, 0], // Set the border color
                },
                theme: "plain",
                body: rows,
                startY: 120,
            });

            const tableHeight = table.autoTable.previous.finalY;

            doc.text("Terms & Conditions", 15, tableHeight + 10);
            doc.text("Terms of Delivery", 15, tableHeight + 15);
            doc.text("Terms of Payment", 15, tableHeight + 20);
            doc.text("Validity", 15, tableHeight + 25);
            doc.text("Remarks", 15, tableHeight + 30);

            doc.text(":", 55, tableHeight + 15);
            doc.text(":", 55, tableHeight + 20);
            doc.text(":", 55, tableHeight + 25);
            doc.text(": ", 55, tableHeight + 30);

            doc.text(
                "a) Payment for completed services to be paid and made payable to",
                60,
                tableHeight + 30
            );
            doc.setFontStyle("bold");

            doc.text(
                "ALAM FLORA ENVIRONMENTAL SOLUTIONS SDN BHD.",
                60,
                tableHeight + 35
            );
            doc.setFontStyle("normal");
            doc.text(
                "b) All price(s) quoted is inclusive of Sales and Services Tax (SST), customs",
                60,
                tableHeight + 40
            );
            doc.text(
                "clerance or taxes and customs agent fees (if any).",
                60,
                tableHeight + 45
            );

            doc.text(
                this.deliveryterm + " " + this.deliverytermunit,
                60,
                tableHeight + 15
            );
            doc.text(this.paymentterm + " Days", 60, tableHeight + 20);
            doc.text(this.validity + " Days", 60, tableHeight + 25);
            var text = this.remarks;
            var x = 60;
            var y = tableHeight + 50;

            var lines = doc.splitTextToSize(
                text,
                doc.internal.pageSize.width - x * 1.3
            );

            if (this.remarks != "" && this.remarks != null) {
                doc.text("c) " + lines[0], x, y);
            }
            for (var i = 1; i < lines.length; i++) {
                if (y + 50 > doc.internal.pageSize.getHeight() - 20) {
                    doc.addPage();
                    y = 25;
                }
                doc.text(lines[i], x, y + 5);
                y += 5;
            }

            var finalYOfText = y;

            doc.text(
                "If you agree with the quotation, please sign in below and send/email it to us as attached as soon as",
                15,
                finalYOfText + 10
            );

            doc.text("possible for further arrangement.", 15, finalYOfText + 15);
            doc.text(
                "Should you need any clarification, please contact " +
                this.companyname +
                " at " +
                this.companyphoneno,
                15,
                finalYOfText + 20
            );
            doc.setFontStyle("bold");

            doc.text(
                "for ALAM FLORA ENVIRONMENTAL SOLUTIONS SDN BHD",
                15,
                finalYOfText + 30
            );
            doc.setFontStyle("normal");

            doc.text(
                "Previously known as DRB-HICOM ENVIRONMENTAL SERVICES SDN BHD",
                15,
                finalYOfText + 35
            );

            doc.setFontStyle("bold");

            doc.addImage(
                sign,
                "PNG",
                doc.internal.pageSize.getWidth() - 195,
                finalYOfText + 40,
                30,
                15
            );

            doc.text("NAZIRA MAHAYUDDIN", 15, finalYOfText + 60);

            doc.setFontStyle("normal");
            doc.text("Senior Manager,", 15, finalYOfText + 65);
            doc.text("Marine Waste Management,", 15, finalYOfText + 70);
            doc.text(
                "Environmental Technology & Solutions Department",
                15,
                finalYOfText + 75
            );

            //acknowledgement start here
            doc.addPage();
            doc.text("TO:", 15, 25);
            doc.setFontStyle("bold");
            doc.text("ALAM FLORA ENVIRONMENTAL SOLUTIONS SDN BHD", 15, 30);
            doc.text("MARINE WASTE MANAGEMENT, PORT RECEPTION FACILITIES", 15, 35);

            doc.setFontStyle("normal");
            doc.text("Attention : " + this.pic1pdf, 15, 45);
            // doc.text("Email : " + this.pic1nopdf, 100, 45);
            doc.text("Email : " + this.pic1emailpdf, 100, 45);

            doc.setFontStyle("bold");
            doc.text("ACKNOWLEDGEMENT / ACCEPTANCE OF OFFER", 60, 55);

            doc.setFontStyle("normal");
            doc.text(
                "I, .................................................................................................. as ................................................................",
                15,
                65
            );

            doc.setFontStyle("italic");

            doc.text("(Name)", 55, 70);
            doc.text("(Designation)", 145, 70);

            doc.setFontStyle("normal");

            doc.text(
                "Agreed to the quotation stated in the above mentioned letter ref no. " +
                this.jobno,
                15,
                80
            );
            doc.text(
                "dated " +
                moment().format("DD MMMM YYYY") +
                " and all terms and condition as mentioned.",
                15,
                85
            );

            doc.text("Thank you.", 15, 95);

            doc.text("Company Name", 15, 105);
            doc.text(
                ": ...............................................................................................................................",
                60,
                105
            );

            doc.text("Company Address", 15, 115);
            doc.text(
                ": ...............................................................................................................................",
                60,
                115
            );
            doc.text(
                ": ...............................................................................................................................",
                60,
                120
            );
            doc.text(
                ": ...............................................................................................................................",
                60,
                125
            );

            doc.text("Contact Person", 15, 135);
            doc.text(
                ": ...............................................................................................................................",
                60,
                135
            );

            doc.text("Designation", 15, 145);
            doc.text(
                ": ...............................................................................................................................",
                60,
                145
            );

            doc.text("Tel. No.", 15, 155);
            doc.text(
                ": ...............................................................................................................................",
                60,
                155
            );

            doc.text("Mobile No.", 15, 165);
            doc.text(
                ": ...............................................................................................................................",
                60,
                165
            );
            doc.text("Email Address", 15, 185);
            doc.text(
                ": ...............................................................................................................................",
                60,
                185
            );

            doc.text("Service to commence", 15, 195);
            doc.text(
                ": ...............................................................................................................................",
                60,
                195
            );

            const xx = 70;
            const xxx = 130;

            const yy = 199;
            const yyy = 209;

            const width = 8;
            const height = 8;

            // Draw the box
            doc.rect(xx, yy, width, height);

            doc.rect(xxx, yy, width, height);

            doc.rect(xx, yyy, width, height);

            doc.rect(xxx, yyy, width, height);

            doc.text("Contract Preferred", 15, 205);
            doc.text(":", 60, 205);
            doc.text("One off job", 80, 205);
            doc.text("*Two (2) years", 140, 205);

            doc.text("*One (1) year", 80, 215);
            doc.text("*Others, please specify", 140, 215);

            doc.setFontStyle("italic");
            doc.text(
                "I/We declare that the data provided is correct and accordingly. I/We also declare that all",
                15,
                225
            );
            doc.text(
                "individuals who are subject of any personal data provided therein have consented to my/our",
                15,
                230
            );
            doc.text(
                'disclosure of the personal data to Alam Flora Environmental Solutions Sdn Bhd ("AFES")',
                15,
                235
            );
            doc.text(
                "(Previously known as DRB-HICOM Environmental Services Sdn Bhd (“DHES”)) and the use",
                15,
                240
            );
            doc.text(
                "by AFES of the personal data in accordance with the policy on personal data attached herein.",
                15,
                245
            );

            doc.text(
                ".......................................................",
                15,
                265
            );
            doc.text("(Signature & Company's Stamp)", 16, 270);

            doc.text(".................................................", 120, 265);
            doc.text("(Date)", 140, 270);

            doc.save("Quotation.pdf");

            console.log("pdf createdd");
        },
        getStatus() {
            this.selects.statuses = [];

            this.$http.get(":10001/api/v1/status/sale").then((res) => {
                if (!res.error) {
                    let response = res.message;

                    for (var i = 0; i < response.length; i++) {
                        let obj = {
                            label: response[i].status,
                            value: response[i].value,
                        };
                        this.selects.statuses.push(obj);
                    }
                }
            });

            this.selects.status = 0;
        },
        disputeQuote() {
            if (this.disputereason != "") {
                let obj = {
                    remark: this.disputereason,
                };

                this.$http
                    .post(
                        ":10001/api/v1/shop/quote/" + this.currentsaleid + "/dispute", obj
                    )
                    .then((res) => {
                        if (!res.error) {
                            swal({
                                title: `Success!`,
                                text: 'Quote dispution success.',
                                buttonsStyling: false,
                                confirmButtonClass: "btn btn-primary btn-fill",
                                type: "success",
                            }).then((result) => {
                                console.log(result);
                                if (result.value) {
                                    this.modals.picdisputereason = false;
                                    this.modals.viewquotation = false;
                                    setTimeout(() => {
                                        this.getData();
                                    }, 1000);
                                    this.disputereason = "";
                                }
                            });
                        } else {
                            console.log("quote not approve", response);
                        }
                    }).catch((err) => {
                        swal({
                            title: `Error!`,
                            text: 'Quote dispution failed.',
                            buttonsStyling: false,
                            confirmButtonClass: "btn btn-cancel btn-fill",
                            type: "error",
                        });
                    });
            } else {
                swal({
                    title: `Info!`,
                    text: "Please fill in the reason",
                    buttonsStyling: false,
                    confirmButtonClass: "btn btn-primary btn-fill",
                    type: "warning",
                });
            }
        },
        rateChange(index) {
            this.totalamount = 0;

            let itemAmount = this.allorderitems[index].rate * this.allorderitems[index].quantity;
            this.allorderitems[index].amount = itemAmount.toFixed(2);

            for (let i = 0; i < this.allorderitems.length - 2; i++) {
                this.totalamount += Number(this.allorderitems[i].amount);
            };

            this.totalamount += Number(this.transportrate);

            console.log('totalamountt ', this.totalamount)
        },

        getRowData(saleid, status) {
            this.totalamount = 0;
            this.oldrate = 0;
            this.transportrate = 0;
            this.allorderitems = [];
            this.allquotationdocs = [];
            this.allpaymentproof = [];
            this.allproformafile = [];
            this.allquotationdisputedocs = [];
            this.allquotedisputedocs = [];
            this.logquotationdisputed = [];

            this.$http
                .get(":10001/api/v1/shop/quote/" + saleid)
                .then((res) => {
                    if (!res.error) {
                        let response = res.message;

                        var totalamount = 0;

                        if (response.issued_by != null) {
                            this.companyname = response.issued_by.user_name;
                            this.companyphoneno = response.issued_by.phone_number;
                        }

                        if (response.address != null)
                            this.companyaddress = response.address.line_1 + "" + response.address.line_2 + "," + response.address.city + "," + response.address.postcode + "," + response.address.state + ", Malaysia.";

                        if (response.address == null)
                            this.companyaddress = 'Self-pickup'
                        this.pagestatus = response.status.status;
                        this.statusname = response.status.name;
                        this.transportrate = response.transport_rate == null ? parseFloat(0).toFixed(2) : parseFloat(response.transport_rate).toFixed(2),

                            this.referenceno = response.reference_number == null || response.reference_number == '' ? '-' : response.reference_number;

                        if (this.positionid != 4) {
                            this.subjectline = response.subject_line == null ? '' : response.subject_line;
                            this.deliveryterm = response.delivery_term == null ? '' : response.delivery_term;
                            this.deliverytermunit = response.delivery_term_unit == null ? '' : response.delivery_term_unit;
                            this.paymentterm = response.payment_term == null ? '' : response.payment_term;
                            this.validity = response.validity == null ? '' : response.validity;
                            this.remarks = response.remark == null ? '' : response.remark;

                        } else if (this.positionid == 4) {
                            this.subjectline = response.subject_line == null ? '-' : response.subject_line;
                            this.deliveryterm = response.delivery_term == null ? '-' : response.delivery_term;
                            this.deliverytermunit = response.delivery_term_unit == null ? '-' : response.delivery_term_unit;
                            this.paymentterm = response.payment_term == null || response.payment_term == '' ? '-' : response.payment_term;
                            this.validity = response.validity == null || response.validity == '' ? '-' : response.validity;
                            this.remarks = response.remark == null || response.remarks == '-' ? '-' : response.remark;
                        }

                        if (response.pic != null) {
                            this.picname = response.pic.user_name == null ? '-' : response.pic.user_name;
                            this.picphoneno = response.pic.phone_number == null ? '-' : response.pic.phone_number;
                        }
                        if (response.service_location != null)
                            this.servicelocation = response.service_location.location == null ? '-' : response.service_location.location;
                        this.customerremark = response.customer_remark == null || response.customer_remark == '' ? '-' : response.customer_remark;

                        this.disputedreason = response.customer_remark == null || response.customer_remark == '' ? '-' : response.customer_remark;

                        if (response.order_ready_by != null)
                            this.proposedate = response.order_ready_by;

                        if (response.order_ready_at != null)
                            this.pickuplocation = response.order_ready_at;

                        console.log('position id', this.positionid);

                        for (let i = 0; i < response.order.length; i++) {
                            let wastetype = {
                                wastetypeid: response.order[i].waste_type.waste_type_id,
                                name: response.order[i].waste_type.name,
                            }

                            let obj = {
                                indexing: i + 1,
                                orderid: response.order[i].order_id,
                                quantity: response.order[i].quantity,
                                remark: response.order[i].remark == '' || response.order[i].remark == null ? '-' : response.order[i].remark,
                                waste_type: wastetype,
                                rate: parseFloat(response.order[i].rate).toFixed(2),

                                ratecent: parseFloat(response.order[i].rate_cent).toFixed(2),
                                amount: (parseFloat(response.order[i].quantity) * parseFloat(response.order[i].rate)).toFixed(2),
                            };
                            var amount = (parseFloat(response.order[i].quantity) * parseFloat(response.order[i].rate)).toFixed(2);
                            if (this.positionid == 4) {
                                console.log('amount', amount);
                                totalamount += parseFloat(amount);
                            }
                            if (this.positionid != 4 && this.pagestatus == 4) {
                                totalamount += parseFloat(amount);
                            }
                            this.allorderitems.push(obj);
                        }

                        totalamount += parseFloat(this.transportrate);

                        console.log("ni order" + totalamount);

                        if (this.positionid != 4 && this.pagestatus == 4) {
                            this.totalamount = totalamount - this.transportrate;
                        }

                        console.log('ni stsatu', status);
                        let transportrate = {
                            name: 'Transportation rate',
                        }
                        let grandtotal = {
                            name: 'GRAND TOTAL',
                        }
                        if (this.positionid != 4) {
                            if (this.pagestatus == 9 || this.pagestatus == 1 || this.pagestatus == 3 || this.pagestatus == 4 || this.pagestatus == 100) {
                                this.allorderitems.push(
                                    {
                                        waste_type: transportrate,
                                    }
                                );
                                this.allorderitems.push(
                                    {
                                        // amount: this.totalamount,
                                        amount: this.pagestatus == 4 ? totalamount.toFixed(2) : '',

                                        waste_type: grandtotal,
                                    }
                                );
                            } else if (status == 9)
                                this.allorderitems.push(
                                    {
                                    }
                                )
                        } else if (this.positionid == 4) {
                            if (this.pagestatus == 9 || this.pagestatus == 2 || this.pagestatus == 100) {
                                this.allorderitems.push(
                                    {
                                        // amount: totalamount,
                                        waste_type: transportrate,
                                    }
                                );
                                this.allorderitems.push(
                                    {
                                        amount: totalamount.toFixed(2),
                                        waste_type: grandtotal,
                                    }
                                );
                            }

                        }

                        if (response.dispute_reason != null)
                            this.quotedisputedreason = response.dispute_reason;

                        if (response.dispute_reason == null && response.dispute_log != null && response.dispute_log.length > 0) {
                            let latestlog = response.dispute_log[response.dispute_log.length - 1];

                            this.quotationdisputedreason = (latestlog.remark == null || latestlog.remark.trim() === '') ? '-' : latestlog.remark;
                        }

                        //get quo docs
                        if (response.quotation_document != null)
                            for (var i = 0; i < response.quotation_document.length; i++) {
                                let obj = {
                                    filename: response.quotation_document[i].meta.filename,
                                    fileurl: response.quotation_document[i].url,
                                    fileid: response.quotation_document[i].document_id,
                                };
                                this.allquotationdocs.push(obj);
                            }

                        if (response.dispute_document != null)
                            for (var i = 0; i < response.dispute_document.length; i++) {
                                let obj = {
                                    filename: response.dispute_document[i].meta.filename,
                                    fileurl: response.dispute_document[i].url,
                                    fileid: response.dispute_document[i].document_id,
                                };
                                this.allquotedisputedocs.push(obj);
                            }

                        if (response.quotation_dispute_document != null)
                            for (var i = 0; i < response.quotation_dispute_document.length; i++) {
                                let obj = {
                                    filename: response.quotation_dispute_document[i].meta.filename,
                                    fileurl: response.quotation_dispute_document[i].url,
                                    fileid: response.quotation_dispute_document[i].document_id,
                                };
                                this.allquotationdisputedocs.push(obj);
                            }

                        if (response.invoice_document != null)
                            for (var i = 0; i < response.invoice_document.length; i++) {
                                let obj = {
                                    filename: response.invoice_document[i].meta.filename,
                                    fileurl: response.invoice_document[i].url,
                                    fileid: response.invoice_document[i].document_id,
                                };
                                this.allpaymentproof.push(obj);
                            }

                        if (response.performa_invoice_document != null)
                            for (var i = 0; i < response.performa_invoice_document.length; i++) {
                                let obj = {
                                    filename: response.performa_invoice_document[i].meta.filename,
                                    fileurl: response.performa_invoice_document[i].url,
                                    fileid: response.performa_invoice_document[i].document_id,
                                };
                                this.allproformafile.push(obj);
                            }

                        //quote disputed
                        //quotation disputed

                        if (response.dispute_log != null)
                            for (
                                var i = 0;
                                i < response.dispute_log.length;
                                i++
                            ) {
                                let obj = {
                                    remark: response.dispute_log[i].remark == null || response.dispute_log[i].remark == '' ? '-' : response.dispute_log[i].remark,
                                    date: moment(response.dispute_log[i].created_at).format("DD-MM-YYYY"), // adjust format
                                    username: response.dispute_log[i].user.user_name,
                                };
                                this.logquotationdisputed.push(obj);
                            }

                    }
                });
        },
        disputeQuotation() {
            if (this.reason != "") {
                let obj = {
                    remark: this.reason,
                };

                this.$http
                    .put(
                        ":10001/api/v1/shop/quote/" + this.currentsaleid + "/quotation/dispute", obj
                    )
                    .then((res) => {
                        if (!res.error) {
                            swal({
                                title: `Success!`,
                                text: 'Quotation dispution success.',
                                buttonsStyling: false,
                                confirmButtonClass: "btn btn-primary btn-fill",
                                type: "success",
                            }).then((result) => {
                                console.log(result);
                                if (result.value) {
                                    this.modals.disputereason = false;
                                    this.modals.viewquotation = false;
                                    setTimeout(() => {
                                        this.getData();
                                    }, 1000);
                                    this.reason = "";
                                }
                            });
                        } else {
                            console.log("quote not approve", response);
                        }
                    }).catch((err) => {
                        swal({
                            title: `Error!`,
                            text: 'Quotation dispution failed.',
                            buttonsStyling: false,
                            confirmButtonClass: "btn btn-cancel btn-fill",
                            type: "error",
                        });
                    });
            } else {
                swal({
                    title: `Info!`,
                    text: "Please fill in the reason",
                    buttonsStyling: false,
                    confirmButtonClass: "btn btn-primary btn-fill",
                    type: "warning",
                });
            }
        },

        generateQuotation() {
            this.$http
                .put(
                    ":10001/api/v1/shop/quote/" + this.currentsaleid + "/quotation/accept"
                )
                .then((res) => {
                    if (!res.error) {
                        swal({
                            title: `Success!`,
                            text: 'Quotation acceptance success.',
                            buttonsStyling: false,
                            confirmButtonClass: "btn btn-primary btn-fill",
                            type: "success",
                        }).then((result) => {
                            console.log(result);
                            if (result.value) {
                                this.modals.viewproforma = false;
                            }
                        });
                    } else {
                        console.log("quote not approve", response);
                    }
                }).catch((err) => {
                    swal({
                        title: `Error!`,
                        text: 'Quotation acceptance failed.',
                        buttonsStyling: false,
                        confirmButtonClass: "btn btn-cancel btn-fill",
                        type: "error",
                    });
                });
        },

        picUpdateQuotation() {
            let order = [];
            for (let i = 0; i < this.allorderitems.length - 2; i++) {
                let obj = {
                    order_id: this.allorderitems[i].orderid,
                    rate: parseInt(this.allorderitems[i].rate),
                    remark: this.allorderitems[i].remark,
                };
                order.push(obj);
            }

            console.log('oder dia', order);

            let obj = {
                transport_rate: parseInt(this.transportrate),
                subject_line: this.subjectline,
                delivery_term: this.deliveryterm,
                delivery_term_unit: this.selects.day,
                payment_term: this.paymentterm,
                payment_term_unit: this.selects.payment,
                validity: this.validity,
                validity_unit: this.selects.validity,
                remark: this.remarks,
                internal_remark: '',
                order: order,
            };

            console.log(obj);

            this.$http
                .put(
                    ":10001/api/v1/shop/quote/" + this.currentsaleid + "/update", obj
                )
                .then((res) => {
                    if (!res.error) {
                        swal({
                            title: `Success!`,
                            text: 'Updating quotation success.',
                            buttonsStyling: false,
                            confirmButtonClass: "btn btn-primary btn-fill",
                            type: "success",
                        }).then((result) => {
                            console.log(result);
                            if (result.value) {
                                this.modals.viewquotation = false;
                                this.modals.viewupdatequotation = false;


                                setTimeout(() => {
                                    this.getData();
                                }, 1000);
                            }
                        });
                    } else {
                        console.log("quote not update", response);
                    }
                }).catch((err) => {
                    swal({
                        title: `Error!`,
                        text: 'Updating quotation failed.',
                        buttonsStyling: false,
                        confirmButtonClass: "btn btn-cancel btn-fill",
                        type: "error",
                    });
                });
        },

        acceptQuotation() {
            this.$http
                .put(
                    ":10001/api/v1/shop/quote/" + this.currentsaleid + "/quotation/accept"
                )
                .then((res) => {
                    if (!res.error) {
                        swal({
                            title: `Success!`,
                            text: 'Quotation acceptance success.',
                            buttonsStyling: false,
                            confirmButtonClass: "btn btn-primary btn-fill",
                            type: "success",
                        }).then((result) => {
                            console.log(result);
                            if (result.value) {
                                this.modals.viewquotation = false;

                                setTimeout(() => {
                                    this.getData();
                                }, 1000);
                            }
                        });
                    } else {
                        console.log("quotation not approve", response);
                    }
                }).catch((err) => {
                    swal({
                        title: `Error!`,
                        text: 'Quotation acceptance failed.',
                        buttonsStyling: false,
                        confirmButtonClass: "btn btn-cancel btn-fill",
                        type: "error",
                    });
                });
        },

        acceptQuote() {
            let order = [];
            for (let i = 0; i < this.allorderitems.length - 2; i++) {
                let obj = {
                    order_id: this.allorderitems[i].orderid,
                    rate: parseInt(this.allorderitems[i].rate),
                    remark: this.allorderitems[i].remark,
                };
                order.push(obj);
            }

            let obj = {
                transport_rate: parseInt(this.transportrate),
                subject_line: this.subjectline,
                delivery_term: this.deliveryterm,
                delivery_term_unit: this.selects.day,
                payment_term: this.paymentterm,
                validity: this.validity,
                remark: this.remarks,
                internal_remark: '',
                order: order,
            };

            console.log(obj);

            this.$http
                .post(
                    ":10001/api/v1/shop/quote/" + this.currentsaleid + "/accept", obj
                )
                .then((res) => {
                    if (!res.error) {
                        swal({
                            title: `Success!`,
                            text: 'Quote acceptance success.',
                            buttonsStyling: false,
                            confirmButtonClass: "btn btn-primary btn-fill",
                            type: "success",
                        }).then((result) => {
                            console.log(result);
                            if (result.value) {
                                this.modals.viewquotation = false;

                                setTimeout(() => {
                                    this.getData();
                                }, 1000);
                            }
                        });
                    } else {
                        console.log("quote not approve", response);
                    }
                }).catch((err) => {
                    swal({
                        title: `Error!`,
                        text: 'Quote acceptance failed.',
                        buttonsStyling: false,
                        confirmButtonClass: "btn btn-cancel btn-fill",
                        type: "error",
                    });
                });
        },

        completeDeliveryOrder() {
            this.$http
                .post(
                    ":10001/api/v1/shop/quote/" + this.currentsaleid + "/complete"
                )
                .then((res) => {
                    if (!res.error) {
                        swal({
                            title: `Success!`,
                            text: 'Completion success.',
                            buttonsStyling: false,
                            confirmButtonClass: "btn btn-primary btn-fill",
                            type: "success",
                        }).then((result) => {
                            console.log(result);
                            if (result.value) {
                                this.modals.viewdeliveryorder = false;

                                setTimeout(() => {
                                    this.getData();
                                }, 1000);
                            }
                        });
                    } else {
                        console.log("quote not approve", response);
                    }
                }).catch((err) => {
                    swal({
                        title: `Error!`,
                        text: 'Completion failed.',
                        buttonsStyling: false,
                        confirmButtonClass: "btn btn-cancel btn-fill",
                        type: "error",
                    });
                });
        },

        submitProforma() {
            this.$http
                .post(
                    ":10001/api/v1/shop/quote/" + this.currentsaleid + "/document/performa-invoice/submit"
                )
                .then((res) => {
                    if (!res.error) {
                        swal({
                            title: `Success!`,
                            text: 'Submission success.',
                            buttonsStyling: false,
                            confirmButtonClass: "btn btn-primary btn-fill",
                            type: "success",
                        }).then((result) => {
                            console.log(result);
                            if (result.value) {
                                this.modals.viewproforma = false;

                                setTimeout(() => {
                                    this.getData();
                                }, 1000);
                            }
                        });
                    } else {
                        console.log("quote not approve", response);
                    }
                }).catch((err) => {
                    swal({
                        title: `Error!`,
                        text: 'Submission failed.',
                        buttonsStyling: false,
                        confirmButtonClass: "btn btn-cancel btn-fill",
                        type: "error",
                    });
                });
        },

        removeProforma(id) {
            swal({
                title: "Are you sure?",
                text: `You won't be able to revert this!`,
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-primary btn-fill",
                cancelButtonClass: "btn btn-cancel btn-fill",
                confirmButtonText: "Continue",
                buttonsStyling: false,
            }).then((result) => {
                console.log(result);
                if (result.value == true) {
                    this.$http
                        .delete(
                            ":10001/api/v1/shop/quote/" + this.currentsaleid + "/document/performa-invoice/" +
                            id
                        )
                        .then((res) => {
                            if (!res.error) {
                                let response = res.message;
                                console.log(response);
                                this.message = response;
                                this.modals.removeModal = true;

                                setTimeout(() => {
                                    this.getRowData(this.currentsaleid, '');
                                }, 1000);
                            } else {
                                let response = res.message;
                                this.message = response;
                                this.modals.removeFailedModal = true;
                            }
                        });
                }
            });
        },

        onFileChangeProforma(event) {
            this.uploadload = true;
            const t = event.target;

            if (t.files.length > 0) {
                const filesArray = Array.from(t.files);

                this.quotitle = filesArray.map(file => file.name).join(', ');

                const uploadPromises = [];

                this.uploadload = true;
                this.buttondisabled = true;

                for (let i = 0; i < filesArray.length; i++) {
                    const input = filesArray[i];
                    const formData = new FormData();
                    formData.append("documents", input);

                    const uploadPromise = this.$http.post(
                        ":10001/api/v1/shop/quote/" + this.currentsaleid + "/document/performa-invoice",
                        formData,
                        {
                            headers: {
                                Authorization: `Bearer ${getStorage("token")}`,
                                "Content-Type": "multipart/form-data",
                            },
                        }
                    ).then((res) => {
                        if (!res.error) {
                            let response = res.message;
                            console.log('why')
                            setTimeout(() => {
                                this.getRowData(this.currentsaleid, '');
                            }, 1000);
                            this.message = response;
                        } else {
                            console.log("data tak masuk");
                            swal({
                                title: "Data Error!",
                                text: `${res.message}`,
                                type: "warning",
                                confirmButtonClass: "btn btn-success btn-fill",
                                confirmButtonText: "Okay",
                                buttonsStyling: false,
                            });
                        }
                    }).catch((error) => {
                        console.error("Upload failed:", error);
                    });

                    uploadPromises.push(uploadPromise);
                }

                Promise.all(uploadPromises).then(() => {
                    this.modals.successModal = true;
                    this.btnsubmit = false;
                    t.value = '';
                }).catch((error) => {
                    console.error("One or more uploads failed:", error);
                }).finally(() => {
                    this.uploadload = false;
                    this.buttondisabled = false;
                });
            } else {
                this.quotitle = "";
            }
        },

        onFileChangeDisputeQuotedocs(event) {
            this.uploadload = true;
            const t = event.target;

            if (t.files.length > 0) {
                const filesArray = Array.from(t.files);

                this.quotitle = filesArray.map(file => file.name).join(', ');

                const uploadPromises = [];

                this.uploadload = true;
                this.buttondisabled = true;

                for (let i = 0; i < filesArray.length; i++) {
                    const input = filesArray[i];
                    const formData = new FormData();
                    formData.append("documents", input);

                    const uploadPromise = this.$http.post(
                        ":10001/api/v1/shop/quote/" + this.currentsaleid + "/document/dispute-document",
                        formData,
                        {
                            headers: {
                                Authorization: `Bearer ${getStorage("token")}`,
                                "Content-Type": "multipart/form-data",
                            },
                        }
                    ).then((res) => {
                        if (!res.error) {
                            let response = res.message;
                            setTimeout(() => {
                                this.getRowData(this.currentsaleid, '');
                            }, 1000);
                            this.message = response;
                        } else {
                            console.log("data tak masuk");
                            swal({
                                title: "Data Error!",
                                text: `${res.message}`,
                                type: "warning",
                                confirmButtonClass: "btn btn-success btn-fill",
                                confirmButtonText: "Okay",
                                buttonsStyling: false,
                            });
                        }
                    }).catch((error) => {
                        console.error("Upload failed:", error);
                    });

                    uploadPromises.push(uploadPromise);
                }

                Promise.all(uploadPromises).then(() => {
                    this.modals.successModal = true;
                    this.btnsubmit = false;
                    t.value = '';
                }).catch((error) => {
                    console.error("One or more uploads failed:", error);
                }).finally(() => {
                    this.uploadload = false;
                    this.buttondisabled = false;
                });
            } else {
                this.quotitle = "";
            }
        },

        removeDisputeQuotedocs(id) {
            swal({
                title: "Are you sure?",
                text: `You won't be able to revert this!`,
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-primary btn-fill",
                cancelButtonClass: "btn btn-cancel btn-fill",
                confirmButtonText: "Continue",
                buttonsStyling: false,
            }).then((result) => {
                console.log(result);
                if (result.value == true) {
                    this.$http
                        .delete(
                            ":10001/api/v1/shop/quote/" + this.currentsaleid + "/document/dispute-document/" +
                            id
                        )
                        .then((res) => {
                            if (!res.error) {
                                let response = res.message;
                                console.log(response);
                                this.message = response;
                                this.modals.removeModal = true;

                                setTimeout(() => {
                                    this.getRowData(this.currentsaleid, '');
                                }, 1000);
                            } else {
                                let response = res.message;
                                this.message = response;
                                this.modals.removeFailedModal = true;
                            }
                        });
                }
            });
        },

        onFileChangeDisputeQuotationdocs(event) {
            this.uploadload = true;
            const t = event.target;

            if (t.files.length > 0) {
                const filesArray = Array.from(t.files);

                this.quotitle = filesArray.map(file => file.name).join(', ');

                const uploadPromises = [];

                this.uploadload = true;
                this.buttondisabled = true;

                for (let i = 0; i < filesArray.length; i++) {
                    const input = filesArray[i];
                    const formData = new FormData();
                    formData.append("documents", input);

                    const uploadPromise = this.$http.post(
                        ":10001/api/v1/shop/quote/" + this.currentsaleid + "/document/quotation-dispute-document",
                        formData,
                        {
                            headers: {
                                Authorization: `Bearer ${getStorage("token")}`,
                                "Content-Type": "multipart/form-data",
                            },
                        }
                    ).then((res) => {
                        if (!res.error) {
                            let response = res.message;
                            setTimeout(() => {
                                this.getRowData(this.currentsaleid, '');
                            }, 1000);
                            this.message = response;
                        } else {
                            console.log("data tak masuk");
                            swal({
                                title: "Data Error!",
                                text: `${res.message}`,
                                type: "warning",
                                confirmButtonClass: "btn btn-success btn-fill",
                                confirmButtonText: "Okay",
                                buttonsStyling: false,
                            });
                        }
                    }).catch((error) => {
                        console.error("Upload failed:", error);
                    });

                    uploadPromises.push(uploadPromise);
                }

                Promise.all(uploadPromises).then(() => {
                    this.modals.successModal = true;
                    this.btnsubmit = false;
                    t.value = '';
                }).catch((error) => {
                    console.error("One or more uploads failed:", error);
                }).finally(() => {
                    this.uploadload = false;
                    this.buttondisabled = false;
                });
            } else {
                this.quotitle = "";
            }
        },

        removeDisputeQuotationdocs(id) {
            swal({
                title: "Are you sure?",
                text: `You won't be able to revert this!`,
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-primary btn-fill",
                cancelButtonClass: "btn btn-cancel btn-fill",
                confirmButtonText: "Continue",
                buttonsStyling: false,
            }).then((result) => {
                console.log(result);
                if (result.value == true) {
                    this.$http
                        .delete(
                            ":10001/api/v1/shop/quote/" + this.currentsaleid + "/document/quotation-dispute-document/" +
                            id
                        )
                        .then((res) => {
                            if (!res.error) {
                                let response = res.message;
                                console.log(response);
                                this.message = response;
                                this.modals.removeModal = true;

                                setTimeout(() => {
                                    this.getRowData(this.currentsaleid, '');
                                }, 1000);
                            } else {
                                let response = res.message;
                                this.message = response;
                                this.modals.removeFailedModal = true;
                            }
                        });
                }
            });
        },

        removeQuoDoc(id) {
            swal({
                title: "Are you sure?",
                text: `You won't be able to revert this!`,
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-primary btn-fill",
                cancelButtonClass: "btn btn-cancel btn-fill",
                confirmButtonText: "Continue",
                buttonsStyling: false,
            }).then((result) => {
                console.log(result);
                if (result.value == true) {
                    this.$http
                        .delete(
                            ":10001/api/v1/shop/quote/" + this.currentsaleid + "/document/accept-quotation/" +
                            id
                        )
                        .then((res) => {
                            if (!res.error) {
                                let response = res.message;
                                console.log(response);
                                this.message = response;
                                this.modals.removeModal = true;

                                setTimeout(() => {
                                    this.getRowData(this.currentsaleid, '');
                                }, 1000);
                            } else {
                                let response = res.message;
                                this.message = response;
                                this.modals.removeFailedModal = true;
                            }
                        });
                }
            });
        },

        onFileChangeQuoDoc(event) {
            this.uploadload = true;
            const t = event.target;

            if (t.files.length > 0) {
                const filesArray = Array.from(t.files);

                this.quotitle = filesArray.map(file => file.name).join(', ');

                const uploadPromises = [];

                this.uploadload = true;
                this.buttondisabled = true;

                for (let i = 0; i < filesArray.length; i++) {
                    const input = filesArray[i];
                    const formData = new FormData();
                    formData.append("documents", input);

                    const uploadPromise = this.$http.post(
                        ":10001/api/v1/shop/quote/" + this.currentsaleid + "/document/accept-quotation",
                        formData,
                        {
                            headers: {
                                Authorization: `Bearer ${getStorage("token")}`,
                                "Content-Type": "multipart/form-data",
                            },
                        }
                    ).then((res) => {
                        if (!res.error) {
                            let response = res.message;
                            setTimeout(() => {
                                this.getRowData(this.currentsaleid);
                            }, 1000);
                            this.message = response;
                        } else {
                            console.log("data tak masuk");
                            swal({
                                title: "Data Error!",
                                text: `${res.message}`,
                                type: "warning",
                                confirmButtonClass: "btn btn-success btn-fill",
                                confirmButtonText: "Okay",
                                buttonsStyling: false,
                            });
                        }
                    }).catch((error) => {
                        console.error("Upload failed:", error);
                    });

                    uploadPromises.push(uploadPromise);
                }

                Promise.all(uploadPromises).then(() => {
                    this.modals.successModal = true;
                    this.btnsubmit = false;
                    t.value = '';
                }).catch((error) => {
                    console.error("One or more uploads failed:", error);
                }).finally(() => {
                    this.uploadload = false;
                    this.buttondisabled = false;
                });

            } else {
                this.quotitle = "";
            }
        },

        tableRowClassName({ row, rowIndex }) {
            if (rowIndex % 2 == 0) {
                let style = { background: "#FFFFFF", color: "#15cf79" };
                return style;
            } else {
                let style = { background: "#f5f6fa", color: "#959595" };
                return style;
            }
        },

        clickRow(row) {
            this.getRowData(row.saleid, row.statusid);

            this.currentsaleid = row.saleid;
            this.currentstatus = row.statusid;

            if (this.positionid != 4) {
                if (row.statusid == 1 || row.statusid == 3) {
                    this.modals.viewquotation = true;
                } else if (row.statusid == 9 || row.statusid == 100) {
                    this.modals.viewdeliveryorder = true;
                } else if (row.statusid == 6) {
                    this.modals.viewproforma = true;
                } else if (row.statusid == 4) {
                    this.modals.viewupdatequotation = true;
                } else {
                    this.modals.viewother = true;
                }
            } else if (this.positionid == 4) {
                if (row.statusid == 2) {
                    this.modals.viewquotation = true;
                } else if (row.statusid == 100 || row.statusid == 9) {
                    this.modals.viewdeliveryorder = true;
                } else {
                    this.modals.viewother = true;
                }
            }


        },
        rowHover(row) {
            const status = row.status;
            // if (status === 'Review Quotation' || status === 'Ready for pickup' || status === 'Proforma Invoice Ready') {
            //   return 'hover-row';
            // }
            return 'hover-row';
        },
        camelCase(str) {
            if (str !== "") {
                let splitStr = str.toLowerCase().split(" ");
                for (let i = 0; i < splitStr.length; i++) {
                    splitStr[i] =
                        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
                }
                return splitStr.join(" ");
            }
            return str;
        },
        getIndex(refno) {
            return refno == document.getElementById("IndexJob").value;
        },
        getData() {
            this.load = true;
            this.tableDatas = [];
            this.temp = [];

            var path = '';
            if (this.search == undefined || this.search == '') {
                path = ':10001/api/v1/shop/quote?size=' + this.pagination.perPage + '&page=' + this.pagination.currentPage + '&status=' + this.selects.status;
            } else {
                path = ':10001/api/v1/shop/quote?size=' + this.pagination.perPage + '&filters=[["reference_number","ilike","' + this.search + '"],["company.company_name", "ilike", "' + this.search + '"]]&page=' + this.pagination.currentPage + '&status=' + this.selects.status
            }

            console.log(path)

            this.$http
                .get(path)
                .then((res) => {
                    if (!res.error) {
                        this.pagination.total = res.message.total;

                        let response = res.message.items;

                        for (let i = 0; i < response.length; i++) {
                            let obj = {
                                index: (i + 1) + (this.pagination.perPage * (this.pagination.currentPage - 1)),
                                saleid: response[i].sale_quotation_id,
                                companyname: response[i].company.company_name,
                                refno:
                                    response[i].reference_number == null || response[i].reference_number == '' ? '-' : response[i].reference_number,
                                // requestdate: moment(response[i].created_at).format(
                                //     "DD-MM-YYYY"
                                // ),
                                requestdate: response[i].created_at,
                                deliverytype: response[i].delivery_type.name,
                                status: this.camelCase(response[i].status.name),
                                statuscolour: response[i].status.status_color,
                                statusid: response[i].status.status,
                                remarks: response[i].customer_remark || "",
                            };
                            this.tableDatas.push(obj);
                            this.temp.push(obj);
                        }

                        this.load = false;
                    }
                });
        },

        dispute() {
            if (this.reason != "") {
                let obj = {
                    quotation_dispute_reason: this.reason,
                };

                this.$http
                    .put(
                        ":10001/api/v1/Sales/" + this.jobno + "/quotation/reject",
                        obj
                    )
                    .then((res) => {
                        if (!res.error) {
                            let response = res.message;
                            this.modals.disputereason = false;
                            this.$router.push("/Sales");
                        }
                    });
            } else {
                // reason is compulsory
                swal({
                    title: `Info!`,
                    text: "Please fill in the reason",
                    buttonsStyling: false,
                    confirmButtonClass: "btn btn-primary btn-fill",
                    type: "warning",
                });
            }
        },
        submit() {
            console.log(this.tableData)
        },
        removeFile(id) {
            this.$http
                .delete(":10001/api/v1/incoming/" + this.jobno + "/invoice-upload")
                .then((res) => {
                    if (!res.error) {
                        let response = res.message;
                        console.log(response);
                        this.message = response;
                        this.modals.removeModal = true;
                        this.getDetail();
                    }
                });
        },
        onInvoiceChange() {
            this.uploadload = true;
            if (this.allInvoice.length < 1) {
                let data = this.$refs.invoicefile.files[0];

                const formData = new FormData();
                formData.append("document", data);

                // to verify form data
                for (var pair of formData.entries()) {
                    console.log(pair);
                }

                this.$http
                    .post(
                        ":10001/api/v1/incoming/" + this.jobno + "/invoice-upload",
                        formData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                Authorization: "Bearer " + sessionStorage.getItem("token"),
                            },
                        }
                    )
                    .then((res) => {
                        if (!res.error) {
                            let response = res.message;
                            console.log(response);
                            this.message = response;
                            this.modals.successModal = true;
                            this.uploadload = false;
                            // swal({
                            //   title: `Success!`,
                            //   text: response,
                            //   buttonsStyling: false,
                            //   confirmButtonClass: "btn btn-primary btn-fill",
                            //   type: "success",
                            // });
                            this.getDetail();
                        }
                    });
            } else {
                swal({
                    title: `Info!`,
                    text: "Only 1 file allowed to be uploaded",
                    buttonsStyling: false,
                    confirmButtonClass: "btn btn-primary btn-fill",
                    type: "info",
                });
                this.uploadload = false;
            }
        },
    },
    created() {
        this.getStatus();
        this.positionid = parseInt(
            JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
                .position_id
        );

        console.log('ni positionid', this.positionid);
        this.getData();
        // this.tableDatas = this.temp;
    },
    computed: {
        piccanapprove() {
            return (this.subjectline === '' || this.deliveryterm === '' || this.paymentterm === '' || this.validity === '')
        },
        cansubmit() {
            return this.allpaymentproof.length === 0;
        },
        cansubmitproforma() {
            return this.allproformafile.length === 0;
        },
        cansubmitdispute() {
            return this.disputereason === '';
        },
        candispute() {
            return this.reason === '';
        },
        canreject() {
            return this.newdate === '';
        },
        canapprove() {
            return this.allquotationdocs.length === 0;
        },
        queriedData() {
            let result = this.tableDatas;
            if (this.searchedData.length > 0) {
                result = this.searchedData;
            }
            return result.slice(this.from, this.to);
        },
    },
    watch: {
        "search"() {
            this.getData();
        },
        searchQuery: debounce(function (search) {
            console.log(search);
            if (search != "") {
                this.tableDatas = this.temp.filter(
                    (value) =>
                        value.refno.toLowerCase().includes(search.toLowerCase()) ||
                        value.companyname.toLowerCase().includes(search.toLowerCase())
                );
            } else {
                this.tableDatas = this.temp;
            }
        }, 500),
        "transportrate"() {
            this.totalamount = (parseFloat(this.totalamount) + parseFloat(this.transportrate) - parseFloat(this.oldrate)).toFixed(2);
            this.oldrate = this.transportrate;

            console.log('transport rate', this.totalamount);
        },
        "scope.row.rate"() {
            this.totalamount = (parseFloat(this.totalamount) + parseFloat(this.transportrate) - parseFloat(this.oldrate)).toFixed(2);
            this.oldrate = this.transportrate;

            console.log('transport rate', this.totalamount);
        },
        "pagination.currentPage"() {
            this.getData();
        },
        "pagination.perPage"() {
            this.getData();
        },
        "pagination.total"() {
            console.log(this.pagination)
            console.log("pagination : ", this.pagination.total)
        },
        activeTab() {
            console.log(this.activeTab);
            if (this.activeTab == 0) {
                this.selects.type = "vessel";
            }
            if (this.activeTab == 1) {
                this.selects.type = "land";
            }
        },
    },

    mounted() {
        this.fuseSearch = new Fuse(this.tableDatas, {
            keys: ["jobno"],
            threshold: 1.0,
        });
    },

}

</script>

<style>
.custom-dropdown .el-select-dropdown {
    background-color: #358CCB;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.custom-dropdown1 .el-input {
    background-color: #358CCB;
}

.custom-table .el-table__body td,
.custom-table .el-table__header th {
    color: #A5A5A5 !important;
}

.customer-name p {
    color: #707070;

}

.customer-name p:hover {
    color: #358CCB;
    /*text-decoration: underline;*/
    cursor: pointer;
}

.status-current {
    text-decoration: none;
}

.status-current:hover {
    text-decoration: underline;
    cursor: pointer;
}


.image-edit-delete:hover {
    cursor: pointer;
}

#modalText p {
    color: grey;
    text-align: left;
    margin-left: 20px;
    font-size: 14px;

}

.subtitle {
    color: #A5A5A5;
    text-align: left;
    font-weight: 600;
    font-size: 18px;
}

.sub-titles {
    margin-top: -5px;
    color: #A5A5A5;
}


.sub-title {
    text-decoration: underline;
    color: #A5A5A5;
    text-align: left;
    font-weight: 600;
    /*font-size: 18px;*/
}

.hover-row {
    cursor: pointer;
}

textarea {
    width: 100%;
    height: 350px;
    padding: 12px 20px;
    box-sizing: border-box;
    border: 1px solid #2b3553;
    border-radius: 4px;
    background-color: transparent;
    font-size: 14px;
    resize: none;
}

.statusview {
    cursor: pointer;
}

.statusview:hover {
    text-decoration: underline;
}
</style>